import { useState, useRef, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import ELAKAY_LOGO from '../Layout/icon/logoelakayDiamant-656.png';
import { elakayAutoText } from "./dataElakay";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["businesscardcreator"]?.[key] || fallback;

// import {ELAKAY_LOGO} from '../Layout/icon/elakayLogo'; 
// //import ELAKAY_LOGO from '../Layout/icon/logoelakayDiamant.svg';



let businesscardcreatorInfoSource;
const businesscardcreatorText = (key, fallback) =>
  businesscardcreatorInfoSource?.laguangeElakay?.("frontElakayHardcodedText", businesscardcreatorInfoSource.languageAPI)?.businesscardcreator?.[key] || fallback;

const QR_API = (data, fg='000000', bg='ffffff') =>
  `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(data)}&color=${fg}&bgcolor=${bg}`;

const FONTS = ["Georgia, serif","Palatino Linotype, Georgia, serif","Garamond, Georgia, serif","Trebuchet MS, sans-serif","Verdana, sans-serif","Impact, Arial Black, sans-serif","Courier New, monospace","Arial, sans-serif","Tahoma, sans-serif","Times New Roman, serif"];
const COLOR_PRESETS = ['#ffffff','#000000','#c9a227','#0070cc','#1D9E75','#dc2626','#a855f7','#f5d060','#4ade80','#818cf8','#888','#caf0f8'];

// ── 10 Background gradient presets ──────────────────────────────────────────
const BG_GRADIENTS = [
  { id:'model',    name:__elakayText("t140", "Default model"), stops:null, dir:'135deg' }, // null = use model's own grad
  { id:'night',    name:__elakayText("t141", "Starry night"),   stops:['#000510','#0a0a2a','#050520'],        dir:'160deg' },
  { id:'gold',     name:__elakayText("t142", "Gold & Black"),      stops:['#0a0800','#1a1400','#2a1e00'],        dir:'135deg' },
  { id:'ocean',    name:__elakayText("t143", "Deep ocean"),  stops:['#000d1a','#001f3f','#000a12'],        dir:'145deg' },
  { id:'fire',     name:__elakayText("t144", "Fire & Embers"),   stops:['#0f0000','#200600','#0f0000'],        dir:'160deg' },
  { id:'forest',   name:__elakayText("t145", "Dark forest"),   stops:['#050f05','#0d1f0d','#020802'],        dir:'140deg' },
  { id:'aurora',   name:__elakayText("t146", "Aurora Borealis"),stops:['#050015','#0a0030','#000a20'],        dir:'150deg' },
  { id:'silver',   name:__elakayText("t147", "Silver & Steel"), stops:['#1a1a1a','#2d2d2d','#111111'],        dir:'135deg' },
  { id:'marble',   name:__elakayText("t148", "White Marble"),   stops:['#f5f5f0','#ece9e0','#fafaf5'],        dir:'120deg' },
  { id:'rose',     name:__elakayText("t149", "Dusty Rose"),    stops:['#1a0010','#2d0018','#0d0008'],        dir:'155deg' },
  { id:'custom',   name:__elakayText("t150", "Custom"),   stops:null, dir:'135deg' }, // user picks colors
];

// ── 20 Layout position presets ───────────────────────────────────────────────
const LAYOUT_PRESETS = [
  { id:'classic',    name:__elakayText("t151", "Classic"),      icon:'▤', blocks:{ logo:{x:4,y:5},  info:{x:4,y:26},  qr:{x:64,y:8}  }},
  { id:'reversed',   name:__elakayText("t152", "Reversed"),        icon:'▧', blocks:{ logo:{x:4,y:5},  info:{x:38,y:26}, qr:{x:3,y:8}   }},
  { id:'centered',   name:__elakayText("t153", "Fully centered"),    icon:'▣', blocks:{ logo:{x:40,y:4}, info:{x:24,y:30}, qr:{x:71,y:20} }},
  { id:'topleft',    name:__elakayText("t154", "Top-left logo"),icon:'⊡',blocks:{ logo:{x:4,y:4},  info:{x:4,y:35},  qr:{x:64,y:12} }},
  { id:'topcenter',  name:__elakayText("t155", "Top-centered logo"),icon:'⊟',blocks:{ logo:{x:42,y:4}, info:{x:4,y:30},  qr:{x:66,y:8}  }},
  { id:'topright',   name:__elakayText("t156", "Top-right logo"),icon:'⊠',blocks:{ logo:{x:78,y:4}, info:{x:4,y:26},  qr:{x:64,y:8}  }},
  { id:'minimal',    name:__elakayText("t157", "Minimal left"),  icon:'▥', blocks:{ logo:{x:4,y:6},  info:{x:4,y:28},  qr:{x:75,y:25} }},
  { id:'editorial',  name:__elakayText("t158", "Editorial"),       icon:'▦', blocks:{ logo:{x:4,y:4},  info:{x:4,y:55},  qr:{x:64,y:8}  }},
  { id:'diagonal',   name:__elakayText("t159", "Diagonal"),        icon:'◈', blocks:{ logo:{x:4,y:4},  info:{x:10,y:35}, qr:{x:68,y:50} }},
  { id:'split',      name:__elakayText("t160", "Split vertical"),  icon:'◫', blocks:{ logo:{x:4,y:4},  info:{x:4,y:26},  qr:{x:64,y:30} }},
  { id:'bottom',     name:__elakayText("t161", "Bottom info"),     icon:'⊥', blocks:{ logo:{x:4,y:4},  info:{x:4,y:62},  qr:{x:64,y:8}  }},
  { id:'luxury',     name:__elakayText("t162", "Centered luxury"),     icon:'✦', blocks:{ logo:{x:42,y:3}, info:{x:14,y:30}, qr:{x:72,y:8}  }},
  { id:'modern',     name:__elakayText("t163", "Modern right"),   icon:'⊢', blocks:{ logo:{x:4,y:8},  info:{x:4,y:38},  qr:{x:67,y:15} }},
  { id:'compact',    name:__elakayText("t164", "Compact"),         icon:'⊕', blocks:{ logo:{x:4,y:8},  info:{x:4,y:24},  qr:{x:63,y:5}  }},
  { id:'portrait',   name:__elakayText("t165", "Portrait"),        icon:'⊛', blocks:{ logo:{x:4,y:5},  info:{x:4,y:28},  qr:{x:75,y:8}  }},
  { id:'studio',     name:__elakayText("t166", "Studio pro"),      icon:'◉', blocks:{ logo:{x:4,y:5},  info:{x:32,y:26}, qr:{x:4,y:22}  }},
  { id:'banner',     name:__elakayText("t167", "Banner"),        icon:'☰', blocks:{ logo:{x:4,y:4},  info:{x:28,y:4},  qr:{x:73,y:8}  }},
  { id:'overlap',    name:__elakayText("t168", "Overlapped"),       icon:'◍', blocks:{ logo:{x:60,y:4}, info:{x:4,y:26},  qr:{x:63,y:28} }},
  { id:'corner',     name:__elakayText("t169", "QR corner"),         icon:'◱', blocks:{ logo:{x:4,y:4},  info:{x:4,y:26},  qr:{x:70,y:55} }},
  { id:'centered2',  name:__elakayText("t170", "Symmetrical centered"),icon:'◎',blocks:{ logo:{x:43,y:5}, info:{x:20,y:38}, qr:{x:68,y:22} }},
];

const CARD_MODELS = [
  // ── 20 Solid models ──────────────────────────────────────────────────────
  
  { id:'noir',      name:__elakayText("t171", "Elite Black"),        fg:'c9a227', bg:'0a0a0a', grad:['#0a0a0a','#1a1a1a'], accent:'#c9a227', accent2:'#e8c547', text:'#ffffff', sub:'#888888', stripe:'linear-gradient(90deg,#c9a227,#e8c547,#c9a227)',           font:'Georgia, serif',
    qr:{ fgColor:'#c9a227', bgColor:'#0a0a0a', bgTransp:false, dotStyle:'square', cornerRadius:0, gradEnabled:false, gradType:'radial', gradColor1:'#c9a227', gradColor2:'#e8c547', gradInvert:false } },
  { id:'gold',      name:__elakayText("t172", "Gold Prestige"),      fg:'f5d060', bg:'1a1200', grad:['#1a1200','#2d1f00'], accent:'#f5d060', accent2:'#c9a227', text:'#fff8e1', sub:'#b8960a', stripe:'linear-gradient(90deg,transparent,#f5d060,transparent)',    font:'Palatino Linotype, Georgia, serif',
    qr:{ fgColor:'#f5d060', bgColor:'#1a1200', bgTransp:false, dotStyle:'rounded', cornerRadius:8, gradEnabled:false, gradType:'radial', gradColor1:'#f5d060', gradColor2:'#c9a227', gradInvert:false } },
  { id:'ocean',     name:__elakayText("t173", "Ocean Pro"),          fg:'00b4d8', bg:'001830', grad:['#001830','#003060'], accent:'#00b4d8', accent2:'#90e0ef', text:'#caf0f8', sub:'#4a9aba', stripe:'linear-gradient(90deg,#00b4d8,#90e0ef,#00b4d8)',             font:'Trebuchet MS, sans-serif',
    qr:{ fgColor:'#00b4d8', bgColor:'#001830', bgTransp:false, dotStyle:'dot', cornerRadius:0, gradEnabled:false, gradType:'radial', gradColor1:'#00b4d8', gradColor2:'#90e0ef', gradInvert:false } },
  { id:'aurora',    name:__elakayText("t174", "Aurora"),             fg:'a855f7', bg:'0d0221', grad:['#0d0221','#1a0533'], accent:'#a855f7', accent2:'#ec4899', text:'#f3e8ff', sub:'#7c5cbf', stripe:'linear-gradient(90deg,#a855f7,#ec4899,#a855f7)',             font:'Verdana, sans-serif',
    qr:{ fgColor:'#a855f7', bgColor:'#0d0221', bgTransp:false, dotStyle:'dot', cornerRadius:0, gradEnabled:false, gradType:'radial', gradColor1:'#a855f7', gradColor2:'#ec4899', gradInvert:false } },
  { id:'marble',    name:__elakayText("t148", "White Marble"),       fg:'1a1a1a', bg:'f8f8f6', grad:['#f8f8f6','#eeece8'], accent:'#1a1a1a', accent2:'#555', text:'#1a1a1a', sub:'#888', stripe:'linear-gradient(90deg,#1a1a1a,#555,#1a1a1a)',                   font:'Garamond, Georgia, serif',
    qr:{ fgColor:'#1a1a1a', bgColor:'#f8f8f6', bgTransp:false, dotStyle:'square', cornerRadius:0, gradEnabled:false, gradType:'radial', gradColor1:'#1a1a1a', gradColor2:'#555555', gradInvert:false } },
  { id:'crimson',   name:__elakayText("t175", "Crimson VIP"),        fg:'dc2626', bg:'0d0000', grad:['#0d0000','#1a0000'], accent:'#dc2626', accent2:'#ef4444', text:'#ffffff', sub:'#994040', stripe:'linear-gradient(90deg,#dc2626,#ef4444,#dc2626)',             font:'Impact, Arial Black, sans-serif',
    qr:{ fgColor:'#dc2626', bgColor:'#0d0000', bgTransp:false, dotStyle:'square', cornerRadius:0, gradEnabled:false, gradType:'radial', gradColor1:'#dc2626', gradColor2:'#ef4444', gradInvert:false } },
  { id:'forest',    name:__elakayText("t176", "Forest Sage"),        fg:'4ade80', bg:'071a0d', grad:['#071a0d','#0f2b16'], accent:'#4ade80', accent2:'#86efac', text:'#dcfce7', sub:'#4a8a60', stripe:'linear-gradient(90deg,#4ade80,#86efac,#4ade80)',             font:'Georgia, serif',
    qr:{ fgColor:'#4ade80', bgColor:'#071a0d', bgTransp:false, dotStyle:'dot', cornerRadius:0, gradEnabled:false, gradType:'radial', gradColor1:'#4ade80', gradColor2:'#86efac', gradInvert:false } },
  { id:'midnight',  name:__elakayText("t177", "Midnight Galaxy"),    fg:'818cf8', bg:'000510', grad:['#000510','#000c22'], accent:'#818cf8', accent2:'#c7d2fe', text:'#e0e7ff', sub:'#4a50aa', stripe:'linear-gradient(90deg,transparent,#818cf8,transparent)',    font:'Courier New, monospace',
    qr:{ fgColor:'#818cf8', bgColor:'#000510', bgTransp:false, dotStyle:'rounded', cornerRadius:8, gradEnabled:false, gradType:'radial', gradColor1:'#818cf8', gradColor2:'#c7d2fe', gradInvert:false } },
  { id:'rose',      name:__elakayText("t178", "Rose Gold"),          fg:'f9a8d4', bg:'1a0010', grad:['#1a0010','#2d0020'], accent:'#f9a8d4', accent2:'#fce7f3', text:'#fce7f3', sub:'#c07090', stripe:'linear-gradient(90deg,#f9a8d4,#fce7f3,#f9a8d4)',             font:'Palatino Linotype, Georgia, serif',
    qr:{ fgColor:'#f9a8d4', bgColor:'#1a0010', bgTransp:false, dotStyle:'dot', cornerRadius:0, gradEnabled:false, gradType:'radial', gradColor1:'#f9a8d4', gradColor2:'#fce7f3', gradInvert:false } },
  { id:'slate',     name:__elakayText("t179", "Slate Pro"),          fg:'94a3b8', bg:'0f172a', grad:['#0f172a','#1e293b'], accent:'#94a3b8', accent2:'#cbd5e1', text:'#e2e8f0', sub:'#64748b', stripe:'linear-gradient(90deg,transparent,#94a3b8,transparent)',    font:'Trebuchet MS, sans-serif',
    qr:{ fgColor:'#94a3b8', bgColor:'#0f172a', bgTransp:false, dotStyle:'rounded', cornerRadius:12, gradEnabled:false, gradType:'radial', gradColor1:'#94a3b8', gradColor2:'#cbd5e1', gradInvert:false } },
  { id:'copper',    name:__elakayText("t180", "Copper Luxe"),        fg:'b45309', bg:'1c0f00', grad:['#1c0f00','#2d1800'], accent:'#d97706', accent2:'#f59e0b', text:'#fef3c7', sub:'#92600a', stripe:'linear-gradient(90deg,#d97706,#f59e0b,#d97706)',             font:'Georgia, serif',
    qr:{ fgColor:'#d97706', bgColor:'#1c0f00', bgTransp:false, dotStyle:'square', cornerRadius:0, gradEnabled:false, gradType:'radial', gradColor1:'#d97706', gradColor2:'#f59e0b', gradInvert:false } },
  { id:'ice',       name:__elakayText("t181", "Arctic Ice"),         fg:'7dd3fc', bg:'0c1445', grad:['#0c1445','#132160'], accent:'#7dd3fc', accent2:'#bae6fd', text:'#e0f2fe', sub:'#4090c0', stripe:'linear-gradient(90deg,#7dd3fc,#bae6fd,#7dd3fc)',             font:'Verdana, sans-serif',
    qr:{ fgColor:'#7dd3fc', bgColor:'#0c1445', bgTransp:false, dotStyle:'dot', cornerRadius:0, gradEnabled:false, gradType:'radial', gradColor1:'#7dd3fc', gradColor2:'#bae6fd', gradInvert:false } },
  { id:'ruby',      name:__elakayText("t182", "Ruby Noir"),          fg:'f43f5e', bg:'0d0008', grad:['#0d0008','#1a0012'], accent:'#f43f5e', accent2:'#fb7185', text:'#fff1f2', sub:'#a03050', stripe:'linear-gradient(90deg,#f43f5e,#fb7185,#f43f5e)',             font:'Impact, Arial Black, sans-serif',
    qr:{ fgColor:'#f43f5e', bgColor:'#0d0008', bgTransp:false, dotStyle:'square', cornerRadius:0, gradEnabled:false, gradType:'radial', gradColor1:'#f43f5e', gradColor2:'#fb7185', gradInvert:false } },
  { id:'sage',      name:__elakayText("t183", "Sage Minimal"),       fg:'6b7280', bg:'f9fafb', grad:['#f9fafb','#f3f4f6'], accent:'#374151', accent2:'#6b7280', text:'#111827', sub:'#9ca3af', stripe:'linear-gradient(90deg,#374151,#6b7280,#374151)',             font:'Garamond, Georgia, serif',
    qr:{ fgColor:'#374151', bgColor:'#f9fafb', bgTransp:false, dotStyle:'square', cornerRadius:4, gradEnabled:false, gradType:'radial', gradColor1:'#374151', gradColor2:'#6b7280', gradInvert:false } },
  { id:'teal',      name:__elakayText("t184", "Teal Prestige"),      fg:'0d9488', bg:'011a18', grad:['#011a18','#02302c'], accent:'#14b8a6', accent2:'#5eead4', text:'#ccfbf1', sub:'#2d8070', stripe:'linear-gradient(90deg,#14b8a6,#5eead4,#14b8a6)',             font:'Trebuchet MS, sans-serif',
    qr:{ fgColor:'#14b8a6', bgColor:'#011a18', bgTransp:false, dotStyle:'rounded', cornerRadius:0, gradEnabled:false, gradType:'radial', gradColor1:'#14b8a6', gradColor2:'#5eead4', gradInvert:false } },
  { id:'champagne', name:__elakayText("t185", "Champagne"),          fg:'d4af37', bg:'1a1600', grad:['#1a1600','#2a2200'], accent:'#d4af37', accent2:'#f0d060', text:'#fdf5d0', sub:'#907830', stripe:'linear-gradient(90deg,transparent,#d4af37,transparent)',    font:'Palatino Linotype, Georgia, serif',
    qr:{ fgColor:'#d4af37', bgColor:'#1a1600', bgTransp:false, dotStyle:'dot', cornerRadius:0, gradEnabled:false, gradType:'radial', gradColor1:'#d4af37', gradColor2:'#f0d060', gradInvert:false } },
  { id:'cobalt',    name:__elakayText("t186", "Cobalt Blue"),        fg:'3b82f6', bg:'030c24', grad:['#030c24','#051438'], accent:'#3b82f6', accent2:'#93c5fd', text:'#dbeafe', sub:'#2860b0', stripe:'linear-gradient(90deg,#3b82f6,#93c5fd,#3b82f6)',             font:'Arial, sans-serif',
    qr:{ fgColor:'#3b82f6', bgColor:'#030c24', bgTransp:false, dotStyle:'rounded', cornerRadius:8, gradEnabled:false, gradType:'radial', gradColor1:'#3b82f6', gradColor2:'#93c5fd', gradInvert:false } },
  { id:'onyx',      name:__elakayText("t187", "Onyx & Silver"),      fg:'c0c0c0', bg:'050505', grad:['#050505','#121212'], accent:'#c0c0c0', accent2:'#e8e8e8', text:'#f0f0f0', sub:'#707070', stripe:'linear-gradient(90deg,#c0c0c0,#e8e8e8,#c0c0c0)',             font:'Tahoma, sans-serif',
    qr:{ fgColor:'#c0c0c0', bgColor:'#050505', bgTransp:false, dotStyle:'square', cornerRadius:0, gradEnabled:false, gradType:'radial', gradColor1:'#c0c0c0', gradColor2:'#e8e8e8', gradInvert:false } },
  { id:'lime',      name:__elakayText("t188", "Lime Energy"),        fg:'84cc16', bg:'0d1a00', grad:['#0d1a00','#162800'], accent:'#84cc16', accent2:'#bef264', text:'#f7fee7', sub:'#4a8010', stripe:'linear-gradient(90deg,#84cc16,#bef264,#84cc16)',             font:'Impact, Arial Black, sans-serif',
    qr:{ fgColor:'#84cc16', bgColor:'#0d1a00', bgTransp:false, dotStyle:'square', cornerRadius:0, gradEnabled:false, gradType:'radial', gradColor1:'#84cc16', gradColor2:'#bef264', gradInvert:false } },
  { id:'sand',      name:__elakayText("t189", "Sand & Earth"),       fg:'a16207', bg:'fdfbf0', grad:['#fdfbf0','#f5f0e0'], accent:'#a16207', accent2:'#ca8a04', text:'#1c1400', sub:'#a08050', stripe:'linear-gradient(90deg,#a16207,#ca8a04,#a16207)',             font:'Georgia, serif',
    qr:{ fgColor:'#a16207', bgColor:'#fdfbf0', bgTransp:false, dotStyle:'square', cornerRadius:4, gradEnabled:false, gradType:'radial', gradColor1:'#a16207', gradColor2:'#ca8a04', gradInvert:false } },

  // ── 10 Gradient models ────────────────────────────────────────────────────
  { id:'grad_sunset',   name:__elakayText("t190", "Sunset Gradient"),    isGradient:true, fg:'ff6b35', bg:'1a0500', grad:['#1a0500','#2d1000'], accent:'#ff6b35', accent2:'#ff8c42', text:'#fff5f0', sub:'#c05030', stripe:'linear-gradient(90deg,#ff6b35,#ffd700,#ff6b35)',       font:'Trebuchet MS, sans-serif',
    qr:{ fgColor:'#ff6b35', bgColor:'#1a0500', bgTransp:false, dotStyle:'rounded', cornerRadius:8, gradEnabled:true, gradType:'radial', gradColor1:'#ff6b35', gradColor2:'#ffd700', gradInvert:false } },
  { id:'grad_ocean',    name:__elakayText("t191", "Ocean Depths"),       isGradient:true, fg:'0ea5e9', bg:'000d1a', grad:['#000d1a','#001830'], accent:'#0ea5e9', accent2:'#38bdf8', text:'#e0f7ff', sub:'#2070a0', stripe:'linear-gradient(90deg,#0ea5e9,#22d3ee,#0ea5e9)',        font:'Verdana, sans-serif',
    qr:{ fgColor:'#0ea5e9', bgColor:'#000d1a', bgTransp:false, dotStyle:'dot', cornerRadius:0, gradEnabled:true, gradType:'linear-h', gradColor1:'#0ea5e9', gradColor2:'#22d3ee', gradInvert:false } },
  { id:'grad_galaxy',   name:__elakayText("t192", "Galaxy Nebula"),      isGradient:true, fg:'c084fc', bg:'05000f', grad:['#05000f','#0d0021'], accent:'#c084fc', accent2:'#f0abfc', text:'#faf0ff', sub:'#7050b0', stripe:'linear-gradient(90deg,#c084fc,#f0abfc,#c084fc)',        font:'Courier New, monospace',
    qr:{ fgColor:'#c084fc', bgColor:'#05000f', bgTransp:false, dotStyle:'dot', cornerRadius:50, gradEnabled:true, gradType:'radial', gradColor1:'#c084fc', gradColor2:'#818cf8', gradInvert:false } },
  { id:'grad_fire',     name:__elakayText("t193", "Fire & Ember"),       isGradient:true, fg:'ef4444', bg:'0f0000', grad:['#0f0000','#200000'], accent:'#ef4444', accent2:'#f97316', text:'#fff1f1', sub:'#a03020', stripe:'linear-gradient(90deg,#ef4444,#f97316,#ef4444)',        font:'Impact, Arial Black, sans-serif',
    qr:{ fgColor:'#ef4444', bgColor:'#0f0000', bgTransp:false, dotStyle:'square', cornerRadius:0, gradEnabled:true, gradType:'linear-d', gradColor1:'#ef4444', gradColor2:'#f97316', gradInvert:false } },
  { id:'grad_mint',     name:__elakayText("t194", "Mint Aurora"),        isGradient:true, fg:'10b981', bg:'00100a', grad:['#00100a','#001a10'], accent:'#10b981', accent2:'#6ee7b7', text:'#ecfdf5', sub:'#208060', stripe:'linear-gradient(90deg,#10b981,#6ee7b7,#10b981)',        font:'Garamond, Georgia, serif',
    qr:{ fgColor:'#10b981', bgColor:'#00100a', bgTransp:false, dotStyle:'rounded', cornerRadius:8, gradEnabled:true, gradType:'radial', gradColor1:'#10b981', gradColor2:'#6ee7b7', gradInvert:false } },
  { id:'grad_neon',     name:__elakayText("t195", "Neon City"),          isGradient:true, fg:'f0ff00', bg:'020202', grad:['#020202','#080808'], accent:'#f0ff00', accent2:'#00ffcc', text:'#f0fff0', sub:'#909000', stripe:'linear-gradient(90deg,#f0ff00,#00ffcc,#f0ff00)',        font:'Courier New, monospace',
    qr:{ fgColor:'#f0ff00', bgColor:'#020202', bgTransp:false, dotStyle:'dot', cornerRadius:0, gradEnabled:true, gradType:'linear-h', gradColor1:'#f0ff00', gradColor2:'#00ffcc', gradInvert:false } },
  { id:'grad_royal',    name:__elakayText("t196", "Royal Purple"),       isGradient:true, fg:'7c3aed', bg:'08001a', grad:['#08001a','#12002d'], accent:'#7c3aed', accent2:'#a78bfa', text:'#ede9fe', sub:'#5030a0', stripe:'linear-gradient(90deg,#7c3aed,#a78bfa,#7c3aed)',        font:'Palatino Linotype, Georgia, serif',
    qr:{ fgColor:'#7c3aed', bgColor:'#08001a', bgTransp:false, dotStyle:'rounded', cornerRadius:8, gradEnabled:true, gradType:'linear-v', gradColor1:'#7c3aed', gradColor2:'#a78bfa', gradInvert:false } },
  { id:'grad_elakay',   name:__elakayText("t197", "Elakay Signature"),   isGradient:true, fg:'c9a227', bg:'000510', grad:['#000510','#000c22'], accent:'#c9a227', accent2:'#818cf8', text:'#fffde7', sub:'#706030', stripe:'linear-gradient(90deg,#c9a227,#818cf8,#c9a227)',        font:'Georgia, serif',
    qr:{ fgColor:'#c9a227', bgColor:'#000510', bgTransp:false, dotStyle:'dot', cornerRadius:0, gradEnabled:true, gradType:'radial', gradColor1:'#c9a227', gradColor2:'#818cf8', gradInvert:false } },
  { id:'grad_dawn',     name:__elakayText("t198", "Dawn Horizon"),       isGradient:true, fg:'fb923c', bg:'08000a', grad:['#08000a','#140015'], accent:'#fb923c', accent2:'#e879f9', text:'#fff7ef', sub:'#a06040', stripe:'linear-gradient(90deg,#fb923c,#e879f9,#fb923c)',        font:'Verdana, sans-serif',
    qr:{ fgColor:'#fb923c', bgColor:'#08000a', bgTransp:false, dotStyle:'rounded', cornerRadius:12, gradEnabled:true, gradType:'linear-d', gradColor1:'#fb923c', gradColor2:'#e879f9', gradInvert:false } },
  { id:'grad_arctic',   name:__elakayText("t199", "Arctic Storm"),       isGradient:true, fg:'38bdf8', bg:'030c24', grad:['#030c24','#051438'], accent:'#38bdf8', accent2:'#e0f2fe', text:'#f0faff', sub:'#2080c0', stripe:'linear-gradient(90deg,#38bdf8,#e0f2fe,#38bdf8)',        font:'Tahoma, sans-serif',
    qr:{ fgColor:'#38bdf8', bgColor:'#030c24', bgTransp:false, dotStyle:'dot', cornerRadius:0, gradEnabled:true, gradType:'radial', gradColor1:'#38bdf8', gradColor2:'#818cf8', gradInvert:false } },
];

// ── Helpers ──────────────────────────────────────────────────────────────────
const hexToRgb = h => [parseInt(h.slice(1,3),16), parseInt(h.slice(3,5),16), parseInt(h.slice(5,7),16)];
const lerp = (a,b,t) => Math.round(a+(b-a)*t);
function loadImg(src) {
  return new Promise((res,rej) => {
    const img = new Image(); img.crossOrigin='anonymous';
    img.onload=()=>res(img); img.onerror=rej; img.src=src;
  });
}

// ── QR Canvas builder (same engine as ImageCombiner) ─────────────────────────
function buildQrCanvas(rawImg, { fgColor, bgColor, bgTransp, logoImg, logoPct, logoRound, logoBg,
  gradEnabled, gradType, gradColor1, gradColor2, gradInvert,
  cornerRadius, dotStyle, dotRadius }) {
  if (!rawImg) return null;
  const SIZE = 600;
  const analysisCvs = document.createElement('canvas');
  analysisCvs.width = analysisCvs.height = SIZE;
  const aC = analysisCvs.getContext('2d');
  aC.drawImage(rawImg, 0, 0, SIZE, SIZE);
  const raw = aC.getImageData(0,0,SIZE,SIZE).data;

  const detectModuleSize = () => {
    let transitions=[], lastDark=null;
    for(let x=10;x<SIZE-10;x++){
      const i=(Math.round(SIZE*0.12)*SIZE+x)*4;
      const lum=0.299*raw[i]+0.587*raw[i+1]+0.114*raw[i+2];
      const dark=lum<128;
      if(lastDark!==null&&dark!==lastDark) transitions.push(x);
      lastDark=dark;
    }
    if(transitions.length<2) return SIZE/25;
    const gaps=[];
    for(let i=1;i<transitions.length;i++) gaps.push(transitions[i]-transitions[i-1]);
    gaps.sort((a,b)=>a-b);
    return gaps[Math.floor(gaps.length/2)]||SIZE/25;
  };
  const modSize = detectModuleSize();

  const offscreen = document.createElement('canvas');
  offscreen.width = offscreen.height = SIZE;
  const ctx = offscreen.getContext('2d');

  if(!bgTransp){ ctx.fillStyle=bgColor; ctx.fillRect(0,0,SIZE,SIZE); }

  const [fgR,fgG,fgB]=hexToRgb(fgColor);
  const [bgR,bgG,bgB]=hexToRgb(bgColor);
  const [g1r,g1g,g1b]=hexToRgb(gradInvert?gradColor2:gradColor1);
  const [g2r,g2g,g2b]=hexToRgb(gradInvert?gradColor1:gradColor2);
  const cx2=SIZE/2,cy2=SIZE/2;
  const maxDist=Math.sqrt(cx2*cx2+cy2*cy2);

  const getModuleColor=(mx,my)=>{
    if(!gradEnabled) return `rgb(${fgR},${fgG},${fgB})`;
    let t=0;
    if(gradType==='radial'){const dx=mx-cx2,dy=my-cy2;t=Math.min(1,Math.sqrt(dx*dx+dy*dy)/maxDist);}
    else if(gradType==='linear-h') t=mx/SIZE;
    else if(gradType==='linear-v') t=my/SIZE;
    else if(gradType==='linear-d') t=(mx+my)/(SIZE*2);
    return `rgb(${lerp(g1r,g2r,t)},${lerp(g1g,g2g,t)},${lerp(g1b,g2b,t)})`;
  };

  if(dotStyle==='square'){
    aC.drawImage(rawImg,0,0,SIZE,SIZE);
    const imgData=aC.getImageData(0,0,SIZE,SIZE);
    const d=imgData.data;
    for(let y=0;y<SIZE;y++){
      for(let x=0;x<SIZE;x++){
        const i=(y*SIZE+x)*4;
        const lum=0.299*d[i]+0.587*d[i+1]+0.114*d[i+2];
        if(lum<128){
          const col=getModuleColor(x,y);
          const [r,g,b]=col.match(/\d+/g).map(Number);
          d[i]=r;d[i+1]=g;d[i+2]=b;d[i+3]=255;
        } else {
          d[i]=bgR;d[i+1]=bgG;d[i+2]=bgB;d[i+3]=bgTransp?0:255;
        }
      }
    }
    ctx.putImageData(imgData,0,0);
  } else {
    const r=(dotRadius/100)*modSize/2;
    const isCircle=dotStyle==='dot';
    for(let row=0;row<Math.ceil(SIZE/modSize);row++){
      for(let col=0;col<Math.ceil(SIZE/modSize);col++){
        const cellX=col*modSize,cellY=row*modSize;
        const sampleX=Math.round(cellX+modSize/2),sampleY=Math.round(cellY+modSize/2);
        if(sampleX>=SIZE||sampleY>=SIZE) continue;
        const si=(sampleY*SIZE+sampleX)*4;
        const lum=0.299*raw[si]+0.587*raw[si+1]+0.114*raw[si+2];
        if(lum>=128) continue;
        const pad=modSize*0.07;
        const mx=cellX+pad,my=cellY+pad,mw=modSize-pad*2,mh=modSize-pad*2;
        const cx3=cellX+modSize/2,cy3=cellY+modSize/2;
        ctx.fillStyle=getModuleColor(cx3,cy3);
        ctx.beginPath();
        if(isCircle){ ctx.arc(cx3,cy3,mw/2,0,Math.PI*2); }
        else { const rr=Math.min(r,mw/2,mh/2); ctx.roundRect(mx,my,mw,mh,rr); }
        ctx.fill();
      }
    }
  }

  if(cornerRadius>0){
    const cr=(cornerRadius/100)*SIZE/2;
    const mask=document.createElement('canvas'); mask.width=mask.height=SIZE;
    const mCtx=mask.getContext('2d');
    mCtx.fillStyle='#000'; mCtx.beginPath(); mCtx.roundRect(0,0,SIZE,SIZE,cr); mCtx.fill();
    const result=document.createElement('canvas'); result.width=result.height=SIZE;
    const rCtx=result.getContext('2d');
    rCtx.drawImage(mask,0,0); rCtx.globalCompositeOperation='source-in'; rCtx.drawImage(offscreen,0,0);
    ctx.clearRect(0,0,SIZE,SIZE); ctx.drawImage(result,0,0);
  }

  if(logoImg){
    const lSize=Math.round(SIZE*(logoPct/100));
    const lx=(SIZE-lSize)/2,ly=(SIZE-lSize)/2;
    const pad=logoBg?8:0;
    if(logoBg){
      ctx.save(); ctx.fillStyle='#ffffff'; ctx.beginPath();
      ctx.roundRect(lx-pad,ly-pad,lSize+pad*2,lSize+pad*2,logoRound+pad); ctx.fill(); ctx.restore();
    }
    ctx.save(); ctx.beginPath(); ctx.roundRect(lx,ly,lSize,lSize,logoRound); ctx.clip();
    ctx.drawImage(logoImg,lx,ly,lSize,lSize); ctx.restore();
  }
  return offscreen;
}


// ── DragBlock: a freely positioned block with a drag handle ──────────────────
function DragBlock({ id, pos, onDrag, editing, selected, onSelect, accentColor, children, minW=60, minH=20 }) {
  const ref = useRef();
  const dragging = useRef(false);
  const offset   = useRef({ ox:0, oy:0 });
  const contRef  = useRef(null);

  const getContainer = () => {
    let el = ref.current;
    while (el && !el.dataset.cardContainer) el = el.parentElement;
    return el;
  };

  const onPointerDown = (e) => {
    if (!editing) return;
    onSelect(id);
    e.stopPropagation();
    e.preventDefault();
    dragging.current = true;
    const rect = ref.current.getBoundingClientRect();
    offset.current = { ox: e.clientX - rect.left, oy: e.clientY - rect.top };
    contRef.current = getContainer();
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', onPointerUp);
  };

  const onPointerMove = (e) => {
    if (!dragging.current || !contRef.current) return;
    const cRect = contRef.current.getBoundingClientRect();
    const W = cRect.width, H = cRect.height;
    const bRect = ref.current.getBoundingClientRect();
    const bW = bRect.width, bH = bRect.height;
    let nx = ((e.clientX - cRect.left - offset.current.ox) / W) * 100;
    let ny = ((e.clientY - cRect.top  - offset.current.oy) / H) * 100;
    const maxX = ((W - bW) / W) * 100;
    const maxY = ((H - bH) / H) * 100;
    nx = Math.max(0, Math.min(maxX, nx));
    ny = Math.max(0, Math.min(maxY, ny));
    onDrag(id, { x: nx, y: ny });
  };

  const onPointerUp = () => {
    dragging.current = false;
    window.removeEventListener('pointermove', onPointerMove);
    window.removeEventListener('pointerup', onPointerUp);
  };

  return (
    <div ref={ref}
      style={{
        position: 'absolute',
        left: `${pos.x}%`,
        top:  `${pos.y}%`,
        cursor: editing ? (selected ? 'grabbing' : 'grab') : 'default',
        outline: editing && selected ? `2px dashed ${accentColor||'#0070cc'}` : editing ? '1px dashed rgba(100,100,200,0.3)' : 'none',
        outlineOffset: 3,
        borderRadius: 4,
        userSelect: 'none',
      }}
      onPointerDown={onPointerDown}
    >
      {children}
      {editing && selected && (
        <div style={{
          position: 'absolute', top: -14, left: 0, right: 0,
          display: 'flex', justifyContent: 'center',
          fontSize: 9, color: accentColor||'#0070cc',
          fontFamily: 'system-ui', pointerEvents: 'none',
          whiteSpace: 'nowrap',
        }}>{businesscardcreatorText("t001", "Move")}</div>
      )}
    </div>
  );
}

// ── CardFace: renders the card with free-positioned blocks ───────────────────
function CardFace({ model: modelId, info, qrCanvas, scale=1, ov={}, logoStyle={},
  blocks, editing=false, selectedBlock, onSelectBlock, onDragBlock, bgGrad=null,
  bgImage=null, bgImageOpacity=100, bgModelOpacity=100, bgImageFit='cover', bgImageBlur=0 }) {

  const W  = Math.round(540*scale);
  const H  = Math.round(300*scale);
  const f  = scale;
  const base = CARD_MODELS.find(c=>c.id===modelId)||CARD_MODELS[0];
  const m  = {...base,...ov};
  const ac = ov.accentColor||m.accent;
  const font = ov.font||m.font;
  const logoSz = Math.round((logoStyle.size||26)*f);
  const logoVisible = logoStyle.show !== false;
  const txAlign = blocks?.info?.textAlign || 'left';

  // Build background
  const bgStops = bgGrad?.stops || m.grad;
  const bgDir   = bgGrad?.dir   || '135deg';
  const bgStr   = bgStops.length === 3
    ? `linear-gradient(${bgDir},${bgStops[0]},${bgStops[1]},${bgStops[2]})`
    : `linear-gradient(${bgDir},${bgStops[0]},${bgStops[1]})`;

  // divider & badge alignment derived from text align
  const dividerMarginLeft = txAlign==='center' ? 'auto' : txAlign==='right' ? 'auto' : undefined;
  const dividerMarginRight= txAlign==='center' ? 'auto' : txAlign==='right' ? 0       : undefined;
  const badgeAlign        = txAlign==='center' ? 'center' : txAlign==='right' ? 'flex-end' : 'flex-start';

  const handleDrag = (id, pos) => onDragBlock && onDragBlock(id, pos);
  const handleSelect = (id) => onSelectBlock && onSelectBlock(id);

  // Default block positions if not provided
  const logoPos = blocks?.logo  || { x:3,  y:5  };
  const infoPos = blocks?.info  || { x:3,  y:26 };
  const qrPos   = blocks?.qr    || { x:65, y:8  };

  // Info block content (width relative to scale)
  const infoMaxW = Math.round(350*f);

  return (
    <div
      data-card-container="1"
      style={{ position:'relative', width:W, height:H, borderRadius:Math.round(12*f),
        background: bgStr,
        overflow:'hidden', flexShrink:0,
        boxShadow:`0 ${Math.round(16*f)}px ${Math.round(48*f)}px rgba(0,0,0,0.45)` }}
      onClick={() => onSelectBlock && onSelectBlock(null)}
    >
    {/* ✨ NEW: Background image layer (sous tout) */}
    {bgImage && (
      <div style={{
        position: 'absolute', inset: 0,
        backgroundImage: `url(${bgImage})`,
        backgroundSize: bgImageFit === 'stretch' ? '100% 100%' : bgImageFit,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        opacity: bgImageOpacity / 100,
        filter: bgImageBlur > 0 ? `blur(${bgImageBlur}px)` : 'none',
        zIndex: 0,
      }}/>
    )}

    {/* ✨ NEW: Model gradient layer (au-dessus de l'image) */}
    <div style={{
      position: 'absolute', inset: 0,
      background: bgStr,
      opacity: bgModelOpacity / 100,
      zIndex: 1,
    }}/>

       {/* Stripes + glow — ajoute zIndex:2 */}
    <div style={{ position:'absolute', top:0, left:0, right:0, height:Math.round(3*f), background:m.stripe, zIndex:2 }} />
    <div style={{ position:'absolute', inset:0, backgroundImage:`radial-gradient(ellipse at 80% 20%,${ac}12 0%,transparent 60%)`, pointerEvents:'none', zIndex:2 }} />
  {/* TOUT TON CONTENU EXISTANT (logo, info, qr) — ajoute juste un wrapper avec zIndex:3 */}
    <div style={{ position:'absolute', inset:0, zIndex:3 }}>
      {/* ── Logo Block ── */}
      {(logoVisible || logoStyle.showText!==false) && (
        <DragBlock id="logo" pos={logoPos} onDrag={handleDrag} editing={editing}
          selected={selectedBlock==='logo'} onSelect={handleSelect} accentColor={ac}>
          <div style={{ display:'flex', alignItems:'center', gap:Math.round(7*f) }}>
 {logoVisible && (
  <div style={{
    /* ✨ NEW : wrapper pour gérer fond + padding */
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: logoStyle.transparentBg ? 'transparent' : (logoStyle.customBg || '#ffffff'),
    padding: Math.round((logoStyle.bgPadding || 0) * f),
    borderRadius: Math.round((logoStyle.radius || 0) * f),
    boxShadow: !logoStyle.transparentBg && (logoStyle.bgPadding || 0) > 0
      ? `0 1px 3px rgba(0,0,0,0.15)` : 'none',
  }}>
    <img
      src={ELAKAY_LOGO}
      alt="E"
      style={{
        width: logoSz,
        height: logoSz,
        objectFit: 'contain',
        borderRadius: Math.round((logoStyle.radius || 0) * f),
        display: 'block',
        /* ✨ Si fond transparent, on enlève tout fond éventuel résiduel */
        background: 'transparent',
      }}
    />
  </div>
)}
            {logoStyle.showText!==false && (
              <span style={{ fontSize:Math.round((logoStyle.textSize||10)*f), fontWeight:logoStyle.textBold?800:700,
                letterSpacing:Math.round(2*f), color:logoStyle.textColor||ac, textTransform:'uppercase',
                fontFamily:font, fontStyle:logoStyle.textItalic?'italic':'normal', whiteSpace:'nowrap' }}>
                {logoStyle.brandText||'ELAKAY'}
              </span>
            )}
          </div>
        </DragBlock>
      )}

      {/* ── Info Block ── */}
      <DragBlock id="info" pos={infoPos} onDrag={handleDrag} editing={editing}
        selected={selectedBlock==='info'} onSelect={handleSelect} accentColor={ac}>
        <div style={{ display:'flex', flexDirection:'column', gap:Math.round(3.5*f), textAlign:txAlign, maxWidth:infoMaxW }}>
          {/* Name */}
          <div style={{ fontSize:Math.round((ov.nameSz||18)*f), fontWeight:ov.nameBold?800:700,
            fontStyle:ov.nameItalic?'italic':'normal', textDecoration:ov.nameUnder?'underline':'none',
            color:ov.nameColor||m.text, fontFamily:font, lineHeight:1.1, letterSpacing:0.3*f, whiteSpace:'nowrap' }}>
            {(info.firstName||'Prénom')+' '+(info.lastName||'Nom')}
          </div>
          {/* Title */}
          {info.title && (
            <div style={{ fontSize:Math.round((ov.titleSz||8.5)*f), color:ov.titleColor||m.accent,
              fontWeight:ov.titleBold?700:600, fontStyle:ov.titleItalic?'italic':'normal',
              letterSpacing:Math.round(1.5*f), textTransform:'uppercase', fontFamily:font, whiteSpace:'nowrap' }}>
              {info.title}
            </div>
          )}
          {/* Divider */}
          <div style={{ width:Math.round(28*f), height:Math.round(1.5*f), background:ac, borderRadius:2,
            marginLeft:dividerMarginLeft, marginRight:dividerMarginRight }} />
          {/* Contacts -- each field keeps its own independent size/style/color
              override (emailSz/emailBold/emailItalic/emailColor, etc.),
              falling back to the old shared contactSz/subColor/accentColor
              so a card saved before this per-field styling existed still
              renders identically (mission: never break a saved model). */}
          <div style={{ display:'flex', flexDirection:'column', gap:Math.round(2.5*f) }}>
            {info.email && (
              <span style={{ fontSize:Math.round((ov.emailSz||ov.contactSz||7.5)*f), color:ov.emailColor||ov.subColor||m.sub,
                fontWeight:ov.emailBold?700:400, fontStyle:ov.emailItalic?'italic':'normal', fontFamily:font, whiteSpace:'nowrap' }}>{info.email}</span>
            )}
            {info.phone && (
              <span style={{ fontSize:Math.round((ov.phoneSz||ov.contactSz||7.5)*f), color:ov.phoneColor||ov.subColor||m.sub,
                fontWeight:ov.phoneBold?700:400, fontStyle:ov.phoneItalic?'italic':'normal', fontFamily:font, whiteSpace:'nowrap' }}>{info.phone}</span>
            )}
            {info.website && (
              <span style={{ fontSize:Math.round((ov.websiteSz||ov.contactSz||7.5)*f), color:ov.websiteColor||ov.accentColor||m.accent2,
                fontWeight:ov.websiteBold?700:400, fontStyle:ov.websiteItalic?'italic':'normal', fontFamily:font, whiteSpace:'nowrap' }}>{info.website}</span>
            )}
            {info.address && (
              <span style={{ fontSize:Math.round((ov.addressSz||ov.contactSz||7)*f), color:ov.addressColor||ov.subColor||m.sub,
                fontWeight:ov.addressBold?700:400, fontStyle:ov.addressItalic?'italic':'normal', fontFamily:font, whiteSpace:'nowrap' }}>{info.address}</span>
            )}
          </div>
          {/* Role badge -- same fallback pattern (ov.roleColor over the old
              always-accent behavior, ov.roleSz over the old fixed 6.5px). */}
          {info.role && (
            <div style={{ alignSelf:badgeAlign, padding:`${Math.round(2.5*f)}px ${Math.round(8*f)}px`,
              borderRadius:Math.round(20*f), background:(ov.roleColor||ac)+'22', border:`0.5px solid ${ov.roleColor||ac}44`,
              display:'inline-flex', alignItems:'center', gap:Math.round(4*f) }}>
              <div style={{ width:Math.round(5*f), height:Math.round(5*f), borderRadius:'50%', background:ov.roleColor||ac }} />
              <span style={{ fontSize:Math.round((ov.roleSz||6.5)*f), color:ov.roleColor||ac, fontWeight:ov.roleBold===false?400:700,
                fontStyle:ov.roleItalic?'italic':'normal',
                letterSpacing:Math.round(1*f), textTransform:'uppercase', fontFamily:font, whiteSpace:'nowrap' }}>{info.role}</span>
            </div>
          )}
        </div>
      </DragBlock>

      {/* ── QR Block ── */}
      {qrCanvas && (
        <DragBlock id="qr" pos={qrPos} onDrag={handleDrag} editing={editing}
          selected={selectedBlock==='qr'} onSelect={handleSelect} accentColor={ac}>
          <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:Math.round(4*f) }}>
            <img src={qrCanvas.toDataURL()} alt="QR"
              style={{ width:Math.round(H*0.5), height:Math.round(H*0.5), borderRadius:Math.round(4*f) }} />
            <span style={{ fontSize:Math.round(5.5*f), color:ov.subColor||m.sub,
              letterSpacing:Math.round(1*f), textTransform:'uppercase', fontFamily:font, whiteSpace:'nowrap' }}>{businesscardcreatorText("t002", "Scan me")}</span>
          </div>
        </DragBlock>
      )}
 </div>
         {/* Bottom stripe */}
    <div style={{ position:'absolute', bottom:0, left:0, right:0, height:Math.round(1.5*f), background:ac+'30', zIndex:2 }} />
    </div>
  );
}


// ── Shared UI ────────────────────────────────────────────────────────────────
const Tc = {
  blue:'#0070cc',blueBg:'#e8f3ff',blueFocus:'rgba(0,112,204,0.1)',
  green:'#1D9E75',greenBg:'#e1f5ee',warn:'#c45000',warnBg:'#fff3e0',
  border:'rgba(0,0,0,0.1)',borderMid:'rgba(0,0,0,0.15)',text:'#1a1a1a',
  muted:'#6c757d',light:'#f5f5f5',headerBg:'#fafafa',white:'#ffffff',
};
const cardS={background:Tc.white,border:`0.5px solid ${Tc.border}`,borderRadius:12,overflow:'hidden',boxShadow:'0 2px 8px rgba(0,0,0,0.06)'};
function SH({bg,color,icon,title,extra}){
  return(<div style={{padding:'11px 14px',borderBottom:`0.5px solid ${Tc.border}`,background:Tc.headerBg,display:'flex',alignItems:'center',gap:8}}>
    <div style={{width:28,height:28,borderRadius:7,background:bg,color,display:'flex',alignItems:'center',justifyContent:'center',fontSize:14}}>{icon}</div>
    <span style={{fontSize:12,fontWeight:600,color:Tc.text}}>{title}</span>
    {extra&&<span style={{marginLeft:'auto',fontSize:10,color:Tc.muted}}>{extra}</span>}
  </div>);
}
function CR({label,value,onChange,presets=[]}){
  return(<div style={{display:'flex',flexDirection:'column',gap:5}}>
    <label style={{fontSize:10,color:Tc.muted}}>{label}</label>
    <div style={{display:'flex',alignItems:'center',gap:6}}>
      <input type="color" value={value} onChange={e=>onChange(e.target.value)} style={{width:34,height:30,border:`0.5px solid ${Tc.border}`,borderRadius:6,cursor:'pointer',padding:2}}/>
      <input type="text" value={value} maxLength={7} onChange={e=>{if(/^#[0-9a-fA-F]{0,6}$/.test(e.target.value))onChange(e.target.value);}} style={{width:76,height:30,padding:'0 8px',borderRadius:6,border:`0.5px solid ${Tc.borderMid}`,fontSize:11,fontFamily:'monospace',outline:'none'}}/>
    </div>
    {presets.length>0&&<div style={{display:'flex',gap:4,flexWrap:'wrap'}}>{presets.map(c=><div key={c} onClick={()=>onChange(c)} title={c} style={{width:20,height:20,borderRadius:4,cursor:'pointer',background:c,border:value===c?`2px solid ${Tc.blue}`:`1px solid ${Tc.border}`,transition:'all .1s'}}/>)}</div>}
  </div>);
}
function TB({label,active,onClick}){
  return(<button onClick={onClick} style={{padding:'4px 10px',borderRadius:6,fontSize:11,cursor:'pointer',fontFamily:'inherit',border:`0.5px solid ${active?Tc.blue:Tc.borderMid}`,background:active?Tc.blueBg:Tc.light,color:active?Tc.blue:Tc.muted,transition:'all .13s',fontWeight:active?700:400}}>{label}</button>);
}
function SliderRow_({label,min,max,step=1,value,onChange,unit=''}){
  return(<div style={{display:'flex',flexDirection:'column',gap:4}}>
    <div style={{display:'flex',justifyContent:'space-between'}}>
      <label style={{fontSize:10,color:Tc.muted}}>{label}</label>
      <span style={{fontSize:11,color:Tc.blue,fontWeight:700}}>{value}{unit}</span>
    </div>
    <input type="range" min={min} max={max} step={step} value={value} onChange={e=>onChange(+e.target.value)} style={{width:'100%',accentColor:Tc.blue}}/>
  </div>);
}


function SliderRow({label,min,max,step=1,value,onChange,unit=''}){
  return(<div style={{display:'flex',flexDirection:'column',gap:4}}>
    <div style={{display:'flex',justifyContent:'space-between'}}>
      <label style={{fontSize:10,color:Tc.muted}}>{label}</label>
      <span style={{fontSize:11,color:Tc.blue,fontWeight:700}}>{value}{unit}</span>
    </div>
    <input type="range" min={min} max={max} step={step} value={value} onChange={e=>onChange(+e.target.value)} style={{width:'100%',accentColor:Tc.blue}}/>
  </div>);
}

function FloatingPanel({ title, children, defaultPos = { x: 100, y: 100 }, defaultSize = { w: 500, h: 400 }, isFloating, onToggleFloat, margins = { top: 12, bottom: 12, left: 12, right: 12 } }) {
  const [pos, setPos]   = useState(defaultPos);
  const [size, setSize] = useState(defaultSize);
  const [dragging, setDragging]   = useState(false);
  const [resizing, setResizing]   = useState(false);
  const [minimized, setMinimized] = useState(false);
  const dragStart = useRef({ mx: 0, my: 0, px: 0, py: 0 });
  const resizeStart = useRef({ mx: 0, my: 0, w: 0, h: 0 });
const T = Tc; // alias for FloatingPanel

  const getViewportLimits = useCallback((panelSize) => {
    const left = Math.max(8, margins.left ?? 8);
    const right = Math.max(8, margins.right ?? 8);
    const top = Math.max(8, margins.top ?? 8);
    const bottom = Math.max(8, margins.bottom ?? 8);
    const maxWidth = Math.max(120, window.innerWidth - left - right);
    const maxHeight = Math.max(120, window.innerHeight - top - bottom);
    const width = Math.min(panelSize.w, maxWidth);
    const height = Math.min(panelSize.h, maxHeight);

    return {
      left,
      top,
      maxWidth,
      maxHeight,
      maxX: Math.max(left, window.innerWidth - right - width),
      maxY: Math.max(top, window.innerHeight - bottom - height),
    };
  }, [margins.bottom, margins.left, margins.right, margins.top]);

  const keepPanelInViewport = useCallback(() => {
    if (!isFloating) return;
    setSize(current => {
      const limits = getViewportLimits(current);
      const next = {
        w: Math.min(current.w, limits.maxWidth),
        h: Math.min(current.h, limits.maxHeight),
      };
      return next.w === current.w && next.h === current.h ? current : next;
    });
    setPos(current => {
      const limits = getViewportLimits(size);
      const next = {
        x: Math.max(limits.left, Math.min(limits.maxX, current.x)),
        y: Math.max(limits.top, Math.min(limits.maxY, current.y)),
      };
      return next.x === current.x && next.y === current.y ? current : next;
    });
  }, [getViewportLimits, isFloating, size]);

  useEffect(() => {
    if (!isFloating) return;
    keepPanelInViewport();
    window.addEventListener('resize', keepPanelInViewport);
    return () => window.removeEventListener('resize', keepPanelInViewport);
  }, [isFloating, keepPanelInViewport]);

  const onDragStart = (e) => {
    if (!isFloating) return;
    e.preventDefault();
    const t = e.touches?.[0] ?? e;
    dragStart.current = { mx: t.clientX, my: t.clientY, px: pos.x, py: pos.y };
    setDragging(true);
  };

  const onResizeStart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const t = e.touches?.[0] ?? e;
    resizeStart.current = { mx: t.clientX, my: t.clientY, w: size.w, h: size.h };
    setResizing(true);
  };

  useEffect(() => {
    if (!dragging && !resizing) return;
    const onMove = (e) => {
      const t = e.touches?.[0] ?? e;
      if (dragging) {
        const dx = t.clientX - dragStart.current.mx;
        const dy = t.clientY - dragStart.current.my;
        const limits = getViewportLimits(size);
        setPos({
          x: Math.max(limits.left, Math.min(limits.maxX, dragStart.current.px + dx)),
          y: Math.max(limits.top, Math.min(limits.maxY, dragStart.current.py + dy)),
        });
      } else if (resizing) {
        const dx = t.clientX - resizeStart.current.mx;
        const dy = t.clientY - resizeStart.current.my;
        const limits = getViewportLimits(size);
        setSize({
          w: Math.min(limits.maxWidth, Math.max(220, resizeStart.current.w + dx)),
          h: Math.min(limits.maxHeight, Math.max(160, resizeStart.current.h + dy)),
        });
      }
    };
    const onUp = () => { setDragging(false); setResizing(false); };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
    window.addEventListener("touchmove", onMove, { passive: false });
    window.addEventListener("touchend", onUp);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
      window.removeEventListener("touchmove", onMove);
      window.removeEventListener("touchend", onUp);
    };
  }, [dragging, resizing, getViewportLimits, size]);

  const containerStyle = isFloating ? {
    position: "fixed",
    left: pos.x, top: pos.y,
    width: size.w, height: minimized ? "auto" : size.h,
    zIndex: 9999,
    background: T.white,
    border: `1px solid ${T.borderMid}`,
    borderRadius: 10,
    boxShadow: "0 12px 40px rgba(0,0,0,0.25)",
    display: "flex", flexDirection: "column",
    overflow: "hidden",
    resize: "none",
  } : {
    width: "100%",
    background: "transparent",
  };

  const panel = (
    <div style={containerStyle}>
      {/* Title bar — only visible when floating */}
      {isFloating && (
        <div
          onMouseDown={onDragStart}
          onTouchStart={onDragStart}
          style={{
            display: "flex", alignItems: "center", gap: 8,
            padding: "8px 12px",
            background: T.headerBg,
            borderBottom: `0.5px solid ${T.border}`,
            cursor: dragging ? "grabbing" : "grab",
            userSelect: "none",
            flexShrink: 0,
          }}
        >
          <span style={{ flex: 1, fontSize: 12, fontWeight: 600, color: T.text }}>
            ⋮⋮ {title}
          </span>
          <button
            onClick={() => setMinimized(m => !m)}
            onMouseDown={e => e.stopPropagation()}
            onTouchStart={e => e.stopPropagation()}
            style={{
              width: 22, height: 22, borderRadius: 4, border: "none",
              background: T.light, cursor: "pointer", fontSize: 11,
              color: T.muted,
            }}
            title={minimized ? elakayAutoText("h_0811e108abbdbd", "Agrandir") : elakayAutoText("h_86a5250550e63f", "Réduire")}
          >{minimized ? "▢" : "_"}</button>
          <button
            onClick={onToggleFloat}
            onMouseDown={e => e.stopPropagation()}
            onTouchStart={e => e.stopPropagation()}
            style={{
              width: 22, height: 22, borderRadius: 4, border: "none",
              background: T.blueBg, cursor: "pointer", fontSize: 11,
              color: T.blue,
            }}
            title={businesscardcreatorText("t003", "Restore")}
          >⇲</button>
        </div>
      )}

      {/* Content */}
      {!minimized && (
        <div style={{
          flex: 1,
          overflow: isFloating ? "auto" : "visible",
          padding: isFloating ? 8 : 0,
          position: "relative",
        }}>
          {children}

          {/* Resize handle */}
          {isFloating && (
            <div
              onMouseDown={onResizeStart}
              onTouchStart={onResizeStart}
              style={{
                position: "absolute", right: 0, bottom: 0,
                width: 18, height: 18, cursor: "nwse-resize",
                background: `linear-gradient(135deg, transparent 50%, ${T.borderMid} 50%, ${T.borderMid} 60%, transparent 60%, transparent 75%, ${T.borderMid} 75%, ${T.borderMid} 85%, transparent 85%)`,
              }}
            />
          )}
        </div>
      )}
    </div>
  );

  return isFloating && typeof document !== 'undefined'
    ? createPortal(panel, document.body)
    : panel;
}

// ── Preset QR codes ──────────────────────────────────────────────────────────
const DEFAULT_QRS = [
  { id: 'qr_elakay',  label: __elakayText("t200", "Elakay.com"),  url: 'https://elakay.com',                        qrUrl: QR_API('https://elakay.com') },
  { id: 'qr_appstore',label: __elakayText("t201", "App Store"),   url: 'https://apps.apple.com',                    qrUrl: QR_API('https://apps.apple.com') },
  { id: 'qr_playstore',label:__elakayText("t202", "Google Play"), url: 'https://play.google.com',                   qrUrl: QR_API('https://play.google.com') },
  { id: 'qr_join',    label: __elakayText("t203", "Rejoindre"),   url: 'https://elakay.com/join',                   qrUrl: QR_API('https://elakay.com/join') },
  { id: 'qr_contact', label: __elakayText("t204", "Contact"),     url: 'https://elakay.com/contact',                qrUrl: QR_API('https://elakay.com/contact') },
  { id: 'qr_shop',    label: __elakayText("t205", "Shop"),    url: 'https://elakay.com/shop',                   qrUrl: QR_API('https://elakay.com/shop') },
  { id: 'qr_linkedin',label: __elakayText("t206", "LinkedIn"),    url: 'https://linkedin.com/in/',                  qrUrl: QR_API('https://linkedin.com/in/') },
  { id: 'qr_whatsapp',label: __elakayText("t207", "WhatsApp"),    url: 'https://wa.me/',                            qrUrl: QR_API('https://wa.me/') },
];


// ── QR Thumbnail (avec sélection visuelle) ───────────────────────────────────
function QrThumb({ qr, selected, onClick, onDelete, isUpload }) {
  return (
    <div style={{
      flexShrink: 0, position: 'relative',
      display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4,
    }}>
      <div onClick={onClick} title={qr.label}
        style={{
          width: 78, height: 78, cursor: 'pointer', position: 'relative',
          borderRadius: 8, overflow: 'hidden',
          border: selected ? `2.5px solid ${Tc.blue}` : `1.5px solid ${Tc.border}`,
          boxShadow: selected ? `0 0 0 3px ${Tc.blueBg}` : '0 1px 3px rgba(0,0,0,0.08)',
          background: '#fff',
          transition: 'all .15s',
        }}>
        <img src={qr.qrUrl} alt={qr.label}
          style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block', padding: 4 }}/>
        {selected && (
          <div style={{
            position: 'absolute', top: 4, right: 4,
            width: 16, height: 16, borderRadius: '50%',
            background: Tc.blue, color: '#fff',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 9, fontWeight: 900,
          }}>✓</div>
        )}
        {isUpload && (
          <div style={{
            position: 'absolute', top: 4, left: 4,
            fontSize: 8, padding: '2px 5px', borderRadius: 4,
            background: 'rgba(0,0,0,0.7)', color: '#fff',
            fontWeight: 600,
          }}>📤</div>
        )}
        {isUpload && onDelete && (
          <button onClick={e => { e.stopPropagation(); onDelete(); }}
            style={{
              position: 'absolute', bottom: 4, right: 4,
              width: 18, height: 18, borderRadius: '50%',
              border: 'none', background: 'rgba(220,53,69,0.9)', color: '#fff',
              fontSize: 10, cursor: 'pointer', fontFamily: 'inherit',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
            title={businesscardcreatorText("t020", "Delete")}
          >×</button>
        )}
      </div>
      <span style={{
        fontSize: 9, color: Tc.muted, maxWidth: 78, textAlign: 'center',
        overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
      }}>{qr.label}</span>
    </div>
  );
}
// ── Main ─────────────────────────────────────────────────────────────────────
export default function BusinessCardCreator(props) {

  const {DEFAULT_QRS =[] , infoSource, userInfo } = props;
  __setElakayInfoSource(infoSource);
  businesscardcreatorInfoSource = infoSource;
  const addresses = infoSource?.userInfo?.address || [];

  const [isPreviewFloating, setIsPreviewFloating] = useState(false);
  // const [selectedAddressId, setSelectedAddressId] = useState(null);
  // ── Liste d'adresses (à recevoir en prop ou via API) ──
// const [addresses, setAddresses] = useState([
//   // Mock data pour test — remplace par tes vraies données
//   {
//     _id: "690d4f7e0de94776e711b210",
//     firstName: "Yves",
//     lastName: "Oxilus",
//     Address1: "226 Norfeld BLVD",
//     Address2: "",
//     city: "Elmont",
//     State: "New york",
//     postalCode: "11003",
//     country: "Us",
//     tel: "+1 347 481 3174",
//     shopName: "yvox",
//     addressDefault: true,
//     BillAddress: true,
//   },
//   {
//     _id: "69dec9b3ebd8601da074a32b",
//     firstName: "Monnoi",
//     lastName: "Oxilus",
//     Address1: "80 moffat st",
//     Address2: "",
//     city: "Brooklyn",
//     State: "New york",
//     postalCode: "11207",
//     country: "Us",
//     tel: "+1 347 782 1232",
//     shopName: "Monnox",
//     addressDefault: false,
//     BillAddress: false,
//   },
// ]);

const [selectedAddressId, setSelectedAddressId] = useState(null);
  // ── Background image personnalisée ──
const [bgImage, setBgImage]               = useState(null);     // dataURL ou URL
const [bgImageOpacity, setBgImageOpacity] = useState(100);      // 0-100
const [bgModelOpacity, setBgModelOpacity] = useState(100);      // 0-100 (opacité du gradient/modèle)
const [bgImageFit, setBgImageFit]         = useState('cover');  // 'cover' | 'contain' | 'stretch'
const [bgImageBlur, setBgImageBlur]       = useState(0);        // 0-20 px
const bgImageUpRef = useRef();


  const [modelId,setModelId]=useState('noir');
  const [info,setInfo]=useState({firstName:'',lastName:'',title:'',role:'',email:'',phone:'',website:'',address:''});
  const [qrData,setQrData]=useState('https://elakay.com');
  const [busy,setBusy]=useState(false);
  const [activeTab,setActiveTab]=useState('solid'); // 'solid' | 'gradient'

  // ── Galerie de QR codes ──
const [qrMode, setQrMode]               = useState('gallery');     // 'gallery' | 'url' | 'upload'
const [selectedQrId, setSelectedQrId]   = useState('qr_elakay');
const [userQrs, setUserQrs]             = useState([]);            // QR uploadés par l'utilisateur
const [qrUrlInput, setQrUrlInput]       = useState('');
const [qrUrlError, setQrUrlError]       = useState('');
const qrGalleryUpRef                    = useRef();

  const base=CARD_MODELS.find(c=>c.id===modelId)||CARD_MODELS[0];
  const [ov,setOv]=useState({});
  const setO=(k,v)=>setOv(p=>({...p,[k]:v}));

  // Logo style
  const [logoStyle, setLogoStyle] = useState({
  show: true,
  showText: true,
  size: 26,
  radius: 0,
  textSize: 10,
  textBold: false,
  textItalic: false,
  textColor: '',
  brandText: 'ELAKAY',
  /* ✨ NEW */
  transparentBg: true,        // logo sans fond par défaut
  customBg: '#ffffff',        // couleur de fond personnalisée si non transparent
  bgPadding: 0,               // padding autour du logo (px)
});
  const setLS=(k,v)=>setLogoStyle(p=>({...p,[k]:v}));

  // ── Modèles sauvegardés ──
const [savedModels, setSavedModels]         = useState([]);
const [selectedSavedId, setSelectedSavedId] = useState(null);
const [saveDialogOpen, setSaveDialogOpen]   = useState(false);
const [modelNameInput, setModelNameInput]   = useState('');

// Charger les modèles sauvegardés au démarrage
useEffect(() => {
  try {
    const raw = localStorage.getItem('elakay:saved-card-models');
    if (raw) setSavedModels(JSON.parse(raw));
  } catch (e) { console.error('Cannot load saved models', e); }
}, []);

// Helper pour persister
const persistSavedModels = (models) => {
  setSavedModels(models);
  try {
    localStorage.setItem('elakay:saved-card-models', JSON.stringify(models));
  } catch (e) { console.error('Cannot save', e); }
};

const fillFromAddress = (addr) => {
  // Reconstitue l'adresse complète sur une ligne
  const fullAddress = [
    addr.Address1,
    addr.Address2,
    addr.city,
    addr.State,
    addr.postalCode,
    addr.country,
  ].filter(Boolean).join(', ');

  setInfo({
    firstName: addr.firstName || '',
    lastName:  addr.lastName  || '',
    title:     info.title,           // garde le titre actuel (n'est pas dans l'adresse)
    role:      info.role,            // idem
    email:     info.email,           // l'adresse n'a pas d'email — on garde l'existant
    phone:     addr.tel || '',
    website:   addr.shopName ? `${addr.shopName.toLowerCase()}.elakay.com` : info.website,
    address:   fullAddress,
  });

  setSelectedAddressId(addr._id);
};

const clearForm = () => {
  setInfo({ firstName:'', lastName:'', title:'', role:'', email:'', phone:'', website:'', address:'' });
  setSelectedAddressId(null);
};

  // Free-position blocks (x,y as % of card)
  const DEFAULT_BLOCKS = { logo:{ x:3, y:5 }, info:{ x:3, y:26 }, qr:{ x:65, y:8 } };
  const [blocks, setBlocks] = useState(DEFAULT_BLOCKS);
  const [selectedBlock, setSelectedBlock] = useState(null);
  const [editMode, setEditMode] = useState(false);
  // Per-block text alignment
  const [infoTextAlign, setInfoTextAlign] = useState('left');

  const updateBlock = (id, pos) => setBlocks(p=>({...p,[id]:pos}));
  const resetBlocks = () => { setBlocks(DEFAULT_BLOCKS); setSelectedBlock(null); };

  // Background gradient state
  const [bgGradId,  setBgGradId]  = useState('model');
  const [bgCustom,  setBgCustom]  = useState({ c1:'#0a0a1a', c2:'#1a1a2e', c3:'#0a0a1a', dir:'135deg', threeStop:true });
  const setBgC = (k,v) => setBgCustom(p=>({...p,[k]:v}));

  // Compute the active bg gradient to pass to CardFace
  const activeBgGrad = (() => {
    if (bgGradId === 'model') return null; // use model's own
    if (bgGradId === 'custom') {
      return { stops: bgCustom.threeStop ? [bgCustom.c1,bgCustom.c2,bgCustom.c3] : [bgCustom.c1,bgCustom.c2], dir: bgCustom.dir };
    }
    const preset = BG_GRADIENTS.find(g=>g.id===bgGradId);
    return preset?.stops ? { stops: preset.stops, dir: preset.dir } : null;
  })();

  // Reset blocks when model changes
  useEffect(()=>{ setOv({}); setBlocks(DEFAULT_BLOCKS); setSelectedBlock(null);
    const m=CARD_MODELS.find(c=>c.id===modelId)||CARD_MODELS[0];
    const qd=m.qr;
    setQrFgColor(qd.fgColor);setQrBgColor(qd.bgColor);setQrBgTransp(qd.bgTransp);
    setQrCornerRadius(qd.cornerRadius);setQrDotStyle(qd.dotStyle);
    setGradEnabled(qd.gradEnabled);setGradType(qd.gradType);setGradColor1(qd.gradColor1);setGradColor2(qd.gradColor2);setGradInvert(qd.gradInvert);
  },[modelId]);

  // QR raw + composed
  const [qrRawImg,setQrRawImg]=useState(null);
  const [qrCanvas,setQrCanvas]=useState(null);

  // QR style — initialized from model defaults, reset when model changes
  const getQrDefaults = (m) => ({ ...m.qr });
  const [qrFgColor,setQrFgColor]=useState(base.qr.fgColor);
  const [qrBgColor,setQrBgColor]=useState(base.qr.bgColor);
  const [qrBgTransp,setQrBgTransp]=useState(base.qr.bgTransp);
  const [qrCornerRadius,setQrCornerRadius]=useState(base.qr.cornerRadius);
  const [qrDotStyle,setQrDotStyle]=useState(base.qr.dotStyle);
  const [qrDotRadius,setQrDotRadius]=useState(30);
  const [gradEnabled,setGradEnabled]=useState(base.qr.gradEnabled);
  const [gradType,setGradType]=useState(base.qr.gradType);
  const [gradColor1,setGradColor1]=useState(base.qr.gradColor1);
  const [gradColor2,setGradColor2]=useState(base.qr.gradColor2);
  const [gradInvert,setGradInvert]=useState(base.qr.gradInvert);
  const [qrLogoImg,setQrLogoImg]=useState(null);
  const [qrLogoPct,setQrLogoPct]=useState(22);
  const [qrLogoRound,setQrLogoRound]=useState(8);
  const [qrLogoBg,setQrLogoBg]=useState(true);
  const qrLogoUpRef=useRef();

  // Charger les QR uploadés depuis localStorage
useEffect(() => {
  try {
    const raw = localStorage.getItem('elakay:user-qrs');
    if (raw) setUserQrs(JSON.parse(raw));
  } catch (e) { /* ignore */ }
}, []);

// Persister les QR uploadés
const persistUserQrs = (qrs) => {
  setUserQrs(qrs);
  try {
    localStorage.setItem('elakay:user-qrs', JSON.stringify(qrs));
  } catch (e) { /* ignore */ }
};


  // Load QR raw from API (plain black/white — we apply color in buildQrCanvas)
  // useEffect(()=>{
  //   if(!qrData.trim()){setQrRawImg(null);return;}
  //   loadImg(QR_API(qrData,'000000','ffffff')).then(img=>setQrRawImg(img)).catch(()=>{});
  // },[qrData]);

  useEffect(() => {
  // Si un QR uploadé est sélectionné, on charge son image directement
  if (selectedQrId) {
    const sel = allQrs.find(q => q.id === selectedQrId);
    if (sel?.isUserUpload && sel.qrUrl) {
      loadImg(sel.qrUrl).then(img => setQrRawImg(img)).catch(() => {});
      return;
    }
  }
  // Sinon, on génère depuis qrData
  if (!qrData.trim()) { setQrRawImg(null); return; }
  loadImg(QR_API(qrData, '000000', 'ffffff')).then(img => setQrRawImg(img)).catch(() => {});
}, [qrData, selectedQrId, userQrs]);

  // Recompose QR
  const recomposeQr=useCallback(()=>{
    if(!qrRawImg){setQrCanvas(null);return;}
    const cvs=buildQrCanvas(qrRawImg,{
      fgColor:qrFgColor,bgColor:qrBgColor,bgTransp:qrBgTransp,
      logoImg:qrLogoImg,logoPct:qrLogoPct,logoRound:qrLogoRound,logoBg:qrLogoBg,
      gradEnabled,gradType,gradColor1,gradColor2,gradInvert,
      cornerRadius:qrCornerRadius,dotStyle:qrDotStyle,dotRadius:qrDotRadius,
    });
    setQrCanvas(cvs||null);
  },[qrRawImg,qrFgColor,qrBgColor,qrBgTransp,qrLogoImg,qrLogoPct,qrLogoRound,qrLogoBg,
     gradEnabled,gradType,gradColor1,gradColor2,gradInvert,qrCornerRadius,qrDotStyle,qrDotRadius]);

  useEffect(()=>{recomposeQr();},[recomposeQr]);

  const setField=(k,v)=>setInfo(p=>({...p,[k]:v}));
  const inputS={width:'100%',height:34,padding:'0 10px',border:`0.5px solid ${Tc.borderMid}`,borderRadius:8,fontSize:12,outline:'none',fontFamily:'inherit',background:Tc.white,color:Tc.text,boxSizing:'border-box'};

  const solidModels    = CARD_MODELS.filter(c=>!c.isGradient);
  const gradientModels = CARD_MODELS.filter(c=>c.isGradient);

  // Download
  const downloadPng=async()=>{
    setBusy(true);
    try{
      const W = 1080, H = 600;
    const cvs = document.createElement('canvas');
    cvs.width = W; cvs.height = H;
    const ctx = cvs.getContext('2d');

         // ✨ Layer 1: Background image
    if (bgImage) {
      try {
        const img = await loadImg(bgImage);
        ctx.save();
        ctx.globalAlpha = bgImageOpacity / 100;
        if (bgImageBlur > 0) ctx.filter = `blur(${bgImageBlur}px)`;
        if (bgImageFit === 'cover') {
          const ratio = Math.max(W / img.width, H / img.height);
          const dw = img.width * ratio, dh = img.height * ratio;
          ctx.drawImage(img, (W - dw) / 2, (H - dh) / 2, dw, dh);
        } else if (bgImageFit === 'contain') {
          const ratio = Math.min(W / img.width, H / img.height);
          const dw = img.width * ratio, dh = img.height * ratio;
          ctx.drawImage(img, (W - dw) / 2, (H - dh) / 2, dw, dh);
        } else { // stretch
          ctx.drawImage(img, 0, 0, W, H);
        }
        ctx.restore();
      } catch (e) { console.error('bgImage load failed', e); }
    }

     // ✨ Layer 2: Model gradient (avec opacité)
    const m = {...base, ...ov};
    const ac = ov.accentColor || m.accent;
    const font = ov.font || m.font;
    const bgStops = activeBgGrad?.stops || [m.grad[0], m.grad[1], m.grad[0]];

    ctx.save();
    ctx.globalAlpha = bgModelOpacity / 100;
    const gr = ctx.createLinearGradient(0, 0, W, H);
    if (bgStops.length === 3) {
      gr.addColorStop(0,    bgStops[0]);
      gr.addColorStop(0.5,  bgStops[1]);
      gr.addColorStop(1,    bgStops[2]);
    } else {
      gr.addColorStop(0, bgStops[0]);
      gr.addColorStop(1, bgStops[1]);
    }
    ctx.fillStyle = gr;
    ctx.fillRect(0, 0, W, H);
    ctx.restore();


      const qzW=Math.round(H*0.72);
      ctx.fillStyle=ac+'10';ctx.fillRect(W-qzW,0,qzW,H);
      ctx.strokeStyle=ac+'20';ctx.lineWidth=1;
      ctx.beginPath();ctx.moveTo(W-qzW,0);ctx.lineTo(W-qzW,H);ctx.stroke();
      const lSz=Math.round((logoStyle.size||26)*2.2);
      // if(logoStyle.show!==false){
      //   await new Promise(res=>{const img=new Image();img.onload=()=>{if(logoStyle.radius>0){ctx.save();ctx.beginPath();ctx.roundRect(44,40,lSz,lSz,logoStyle.radius*2);ctx.clip();ctx.drawImage(img,44,40,lSz,lSz);ctx.restore();}else{ctx.drawImage(img,44,40,lSz,lSz);}res();};img.onerror=res;img.src=ELAKAY_LOGO;});
      // }

      if (logoStyle.show !== false) {
  await new Promise(res => {
    const img = new Image();
    img.onload = () => {
      const padding = (logoStyle.bgPadding || 0) * 2.2; // scale up for HD
      const radius  = logoStyle.radius * 2;

      // ✨ Dessine le fond seulement si non-transparent
      if (!logoStyle.transparentBg) {
        ctx.save();
        ctx.fillStyle = logoStyle.customBg || '#ffffff';
        ctx.beginPath();
        ctx.roundRect(
          44 - padding, 40 - padding,
          lSz + padding * 2, lSz + padding * 2,
          radius + padding
        );
        ctx.fill();
        // Petite ombre douce
        if (padding > 0) {
          ctx.shadowColor = 'rgba(0,0,0,0.15)';
          ctx.shadowBlur = 4;
          ctx.shadowOffsetY = 2;
        }
        ctx.restore();
      }

      // Logo lui-même
      if (logoStyle.radius > 0) {
        ctx.save();
        ctx.beginPath();
        ctx.roundRect(44, 40, lSz, lSz, radius);
        ctx.clip();
        ctx.drawImage(img, 44, 40, lSz, lSz);
        ctx.restore();
      } else {
        ctx.drawImage(img, 44, 40, lSz, lSz);
      }
      res();
    };
    img.onerror = res;
    img.src = ELAKAY_LOGO;
  });
}
      if(logoStyle.showText!==false){ctx.fillStyle=logoStyle.textColor||ac;ctx.font=`${logoStyle.textBold?'bold ':''}${logoStyle.textItalic?'italic ':''}${Math.round((logoStyle.textSize||10)*2.2)}px Trebuchet MS`;ctx.fillText(logoStyle.brandText||'ELAKAY',44+lSz+14,40+lSz*0.65);}
      const nameColor=ov.nameColor||m.text,titleColor=ov.titleColor||m.accent,subColor=ov.subColor||m.sub;
      const nameSz=ov.nameSz||18,titleSz=ov.titleSz||8.5;
      const roleColor=ov.roleColor||ac;
      // Each contact field keeps its own size/style/color override, falling
      // back to the old shared contactSz/subColor/accentColor so a card
      // saved before this per-field styling existed still exports the same
      // PNG as before (mission: never break a saved model).
      const emailColor=ov.emailColor||subColor, emailSz=ov.emailSz||ov.contactSz||7.5;
      const phoneColor=ov.phoneColor||subColor, phoneSz=ov.phoneSz||ov.contactSz||7.5;
      const websiteColor=ov.websiteColor||ov.accentColor||m.accent2, websiteSz=ov.websiteSz||ov.contactSz||7.5;
      const addressColor=ov.addressColor||subColor, addressSz=ov.addressSz||ov.contactSz||7;
      ctx.fillStyle=nameColor;ctx.font=`${ov.nameBold?'bold ':''}${ov.nameItalic?'italic ':''}${Math.round(nameSz*3)}px ${font}`.trim();
      ctx.fillText(((info.firstName||'Prénom')+' '+(info.lastName||'Nom')).trim(),44,190);
      if(info.title){ctx.fillStyle=titleColor;ctx.font=`${ov.titleBold?'bold ':''}${ov.titleItalic?'italic ':''}${Math.round(titleSz*3)}px ${font}`.trim();ctx.fillText(info.title.toUpperCase(),44,228);}
      ctx.fillStyle=ac;ctx.fillRect(44,248,64,3);
      let cy=280;
      if(info.email){ctx.fillStyle=emailColor;ctx.font=`${ov.emailBold?'bold ':''}${ov.emailItalic?'italic ':''}${Math.round(emailSz*2.8)}px ${font}`.trim();ctx.fillText(info.email,44,cy);cy+=30;}
      if(info.phone){ctx.fillStyle=phoneColor;ctx.font=`${ov.phoneBold?'bold ':''}${ov.phoneItalic?'italic ':''}${Math.round(phoneSz*2.8)}px ${font}`.trim();ctx.fillText(info.phone,44,cy);cy+=30;}
      if(info.website){ctx.fillStyle=websiteColor;ctx.font=`${ov.websiteBold?'bold ':''}${ov.websiteItalic?'italic ':''}${Math.round(websiteSz*2.8)}px ${font}`.trim();ctx.fillText(info.website,44,cy);cy+=30;}
      if(info.address){ctx.fillStyle=addressColor;ctx.font=`${ov.addressBold?'bold ':''}${ov.addressItalic?'italic ':''}${Math.round(addressSz*2.8)}px ${font}`.trim();ctx.fillText(info.address,44,cy);}
      if(info.role){ctx.fillStyle=roleColor+'28';ctx.beginPath();ctx.roundRect(44,H-74,240,36,18);ctx.fill();ctx.fillStyle=roleColor;ctx.font=`${ov.roleBold===false?'':'bold '}${ov.roleItalic?'italic ':''}${Math.round((ov.roleSz||6.5)*2.3)}px ${font}`.trim();ctx.fillText('● '+info.role.toUpperCase(),58,H-50);}
      if(qrCanvas){const qs=Math.round(H*0.52);const qx=W-qzW+(qzW-qs)/2;const qy=(H-qs)/2;ctx.drawImage(qrCanvas,qx,qy,qs,qs);ctx.fillStyle=subColor;ctx.font='15px Trebuchet MS';ctx.textAlign='center';ctx.fillText('SCAN ME',W-qzW/2,qy+qs+24);ctx.textAlign='left';}
      ctx.fillStyle=ac+'40';ctx.fillRect(0,H-3,W,3);
      ctx.globalCompositeOperation='destination-in';ctx.fillStyle='#000';ctx.beginPath();ctx.roundRect(0,0,W,H,24);ctx.fill();ctx.globalCompositeOperation='source-over';
      const a=document.createElement('a');a.href=cvs.toDataURL('image/png');a.download=`elakay-card-${modelId}.png`;a.click();
    }catch(e){console.error(e);}
    setBusy(false);
  };

  const gradPreviewStyle = (t, c1, c2, inv) => {
    const a=inv?c2:c1, b=inv?c1:c2;
    if(t==='radial') return `radial-gradient(circle,${a},${b})`;
    if(t==='linear-h') return `linear-gradient(to right,${a},${b})`;
    if(t==='linear-v') return `linear-gradient(to bottom,${a},${b})`;
    return `linear-gradient(135deg,${a},${b})`;
  };

  /* ─── Save current model (all settings except address) ─── */
const saveCurrentModel = (customName = '') => {
  const name = (customName || modelNameInput).trim() || `Modèle ${savedModels.length + 1}`;
  const id   = `model_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

  const snapshot = {
    id,
    name,
    createdAt: new Date().toISOString(),
    thumbnail: null, // optionally generate later

    /* ── Core ── */
    modelId,
    activeTab,

    /* ── Info (sans address ni nom/contacts personnels) ── */
    info: {
      title:   info.title,
      role:    info.role,
      website: info.website,
      // Note : firstName, lastName, email, phone, address sont volontairement exclus
    },

    /* ── Style overrides ── */
    ov: { ...ov },

    /* ── Logo style ── */
    logoStyle: { ...logoStyle },

    /* ── Block positions ── */
    blocks: { ...blocks },
    infoTextAlign,

    /* ── Background gradient ── */
    bgGradId,
    bgCustom: { ...bgCustom },

    /* ── Background image ── */
    bgImage,
    bgImageOpacity,
    bgModelOpacity,
    bgImageFit,
    bgImageBlur,

    /* ── QR style ── */
    qrData,
    qrStyle: {
      qrFgColor,
      qrBgColor,
      qrBgTransp,
      qrCornerRadius,
      qrDotStyle,
      qrDotRadius,
      gradEnabled,
      gradType,
      gradColor1,
      gradColor2,
      gradInvert,
      qrLogoPct,
      qrLogoRound,
      qrLogoBg,
      // qrLogoImg n'est pas sauvé (image en mémoire) — pourrait être encodé en base64 si voulu
    },
  };

  const updated = [snapshot, ...savedModels];
  persistSavedModels(updated);

  setSelectedSavedId(id);
  setSaveDialogOpen(false);
  setModelNameInput('');

};

/* ─── Load (apply) a saved model ─── */
const loadSavedModel = (saved) => {
  if (!saved) return;

  /* Core */
  setModelId(saved.modelId);
  if (saved.activeTab) setActiveTab(saved.activeTab);

  /* Info (sans écraser nom/contacts personnels actuels) */
  setInfo(prev => ({
    ...prev,
    title:   saved.info?.title   ?? prev.title,
    role:    saved.info?.role    ?? prev.role,
    website: saved.info?.website ?? prev.website,
  }));

  /* Style overrides */
  setOv(saved.ov || {});

  /* Logo style */
  if (saved.logoStyle) setLogoStyle(saved.logoStyle);

  /* Blocks */
  if (saved.blocks) setBlocks(saved.blocks);
  if (saved.infoTextAlign) setInfoTextAlign(saved.infoTextAlign);

  /* Background gradient */
  if (saved.bgGradId)  setBgGradId(saved.bgGradId);
  if (saved.bgCustom)  setBgCustom(saved.bgCustom);

  /* Background image */
  setBgImage(saved.bgImage || null);
  setBgImageOpacity(saved.bgImageOpacity ?? 100);
  setBgModelOpacity(saved.bgModelOpacity ?? 100);
  setBgImageFit(saved.bgImageFit || 'cover');
  setBgImageBlur(saved.bgImageBlur ?? 0);

  /* QR style */
  if (saved.qrData) setQrData(saved.qrData);
  if (saved.qrStyle) {
    const q = saved.qrStyle;
    setQrFgColor(q.qrFgColor);
    setQrBgColor(q.qrBgColor);
    setQrBgTransp(q.qrBgTransp);
    setQrCornerRadius(q.qrCornerRadius);
    setQrDotStyle(q.qrDotStyle);
    setQrDotRadius(q.qrDotRadius ?? 30);
    setGradEnabled(q.gradEnabled);
    setGradType(q.gradType);
    setGradColor1(q.gradColor1);
    setGradColor2(q.gradColor2);
    setGradInvert(q.gradInvert);
    setQrLogoPct(q.qrLogoPct ?? 22);
    setQrLogoRound(q.qrLogoRound ?? 8);
    setQrLogoBg(q.qrLogoBg ?? true);
  }

  setSelectedSavedId(saved.id);
};

/* ─── Delete a saved model ─── */
const deleteSavedModel = (id) => {
  if (!window.confirm(__elakayText("t208", "Supprimer ce modèle ?"))) return;
  const updated = savedModels.filter(m => m.id !== id);
  persistSavedModels(updated);
  if (selectedSavedId === id) setSelectedSavedId(null);
};

/* ─── Rename a saved model ─── */
const renameSavedModel = (id, newName) => {
  const updated = savedModels.map(m => m.id === id ? { ...m, name: newName } : m);
  persistSavedModels(updated);
};

/* ─── Duplicate a saved model ─── */
const duplicateSavedModel = (saved) => {
  const copy = {
    ...saved,
    id:   `model_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    name: `${saved.name} (copie)`,
    createdAt: new Date().toISOString(),
  };
  persistSavedModels([copy, ...savedModels]);
};

/* ─── Export / Import ─── */
const exportModelsAsJson = () => {
  const data = JSON.stringify(savedModels, null, 2);
  const blob = new Blob([data], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `elakay-card-models-${new Date().toISOString().slice(0,10)}.json`;
  a.click();
  URL.revokeObjectURL(url);
};

const importModelsFromJson = (file) => {
  if (!file) return;
  const reader = new FileReader();
  reader.onload = e => {
    try {
      const imported = JSON.parse(e.target.result);
      if (!Array.isArray(imported)) throw new Error('Invalid format');
      persistSavedModels([...imported, ...savedModels]);
      alert(elakayAutoText("h_b5e903be09a992", "✓ {value0} modèle(s) importé(s)", { value0: imported.length }));
    } catch (err) {
      alert(__elakayText("t209", "❌ Fichier invalide"));
    }
  };
  reader.readAsText(file);
};

const allQrs = [...DEFAULT_QRS, ...userQrs];

/* ─── Select a QR from the gallery ─── */
const selectQr = (qr) => {
  setSelectedQrId(qr.id);
  setQrData(qr.url);  // déclenche le rechargement automatique du qrRawImg via useEffect
};

/* ─── Load QR from external URL (image directement) ─── */
const loadQrFromExternalUrl = async () => {
  const u = qrUrlInput.trim();
  if (!u) { setQrUrlError('Entrez une URL valide.'); return; }
  try {
    setQrUrlError('');
    const img = await loadImg(u);
    setQrRawImg(img);
    setQrUrlError('✓ Image QR chargée !');
    setSelectedQrId(null); // déselection de la galerie
  } catch {
    setQrUrlError('❌ Impossible de charger cette URL (CORS ?).');
  }
};

/* ─── Upload a QR image ─── */
const addUserQr = async (file) => {
  if (!file?.type.startsWith('image/')) return;
  const reader = new FileReader();
  reader.onload = async (e) => {
    const dataUrl = e.target.result;
    const id = `uq_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`;
    const newQr = {
      id,
      label: file.name.replace(/\.[^.]+$/, '').slice(0, 20),
      url: '',                  // pas d'URL d'origine
      qrUrl: dataUrl,           // l'image elle-même en base64
      isUserUpload: true,
    };
    const updated = [...userQrs, newQr];
    persistUserQrs(updated);

    // Charger directement comme QR actif
    const img = await loadImg(dataUrl);
    setQrRawImg(img);
    setSelectedQrId(id);
  };
  reader.readAsDataURL(file);
};

/* ─── Delete a user QR ─── */
const deleteUserQr = (id) => {
  if (!window.confirm(__elakayText("t210", "Supprimer ce QR code ?"))) return;
  const updated = userQrs.filter(q => q.id !== id);
  persistUserQrs(updated);
  if (selectedQrId === id) {
    selectQr(DEFAULT_QRS[0]);
  }
};

/* ─── Generate a custom QR from any URL ─── */
const generateCustomQr = (urlOrText) => {
  const v = (urlOrText || '').trim();
  if (!v) return;
  const qrApiUrl = QR_API(v);
  setQrData(v);
  setSelectedQrId(null);
  loadImg(qrApiUrl).then(img => {
    setQrRawImg(img);
    setQrUrlError('✓ QR généré !');
  }).catch(() => setQrUrlError('❌ Erreur de génération.'));
};

  return (
    <div style={{fontFamily:"'Segoe UI',system-ui,sans-serif",display:'flex',flexDirection:'column',gap:16}}>

      <div style={{textAlign:'center',padding:'14px 0 4px'}}>
        <div style={{fontSize:9,letterSpacing:5,color:'#999',marginBottom:6}}>{businesscardcreatorText("t005", "ELAKAY - CARD CREATOR")}</div>
        <h2 style={{margin:0,fontSize:22,fontWeight:900,color:Tc.text,letterSpacing:-0.5}}>{__elakayText("t100", "Cartes de Visite")}</h2>
        <p style={{color:Tc.muted,fontSize:12,marginTop:4}}>{businesscardcreatorText("t007", "30 templates - 10 gradients - custom QR - HD PNG")}</p>
      </div>

      {/* ── Model selector ── */}
      <div style={cardS}>
        <SH bg="#e0f0ff" color="#0070cc" icon="🎨" title={businesscardcreatorText("t008", "Choose a template (30 available)")} extra={base.name}/>
        <div style={{padding:'10px 14px 0'}}>
          {/* Tab switcher */}
          <div style={{display:'flex',gap:6,marginBottom:12}}>
            {[{id:'solid',lbl:`⬛ Solides (${solidModels.length})`},{id:'gradient',lbl:`🌈 Gradient (${gradientModels.length})`}].map(t=>(
              <button key={t.id} onClick={()=>setActiveTab(t.id)} style={{padding:'6px 14px',borderRadius:20,fontSize:11,fontWeight:600,cursor:'pointer',fontFamily:'inherit',border:`1px solid ${activeTab===t.id?Tc.blue:Tc.borderMid}`,background:activeTab===t.id?Tc.blue:Tc.light,color:activeTab===t.id?'#fff':Tc.muted,transition:'all .15s'}}>{t.lbl}</button>
            ))}
          </div>
          <div style={{display:'flex',gap:10,overflowX:'auto',paddingBottom:14}}>
            {(activeTab==='solid'?solidModels:gradientModels).map(cm=>(
              <div key={cm.id} onClick={()=>setModelId(cm.id)} style={{flexShrink:0,cursor:'pointer',borderRadius:10,overflow:'hidden',border:modelId===cm.id?`2.5px solid ${Tc.blue}`:`1.5px solid ${Tc.border}`,boxShadow:modelId===cm.id?`0 0 0 3px ${Tc.blueBg}`:'none',transition:'all .15s',position:'relative'}}>
                <CardFace model={cm.id} info={info} qrCanvas={null} scale={130/540} ov={{}} logoStyle={logoStyle} blocks={DEFAULT_BLOCKS} bgGrad={null}/>
                <div style={{padding:'5px 8px',background:modelId===cm.id?Tc.blueBg:Tc.light,textAlign:'center'}}>
                  <span style={{fontSize:9,fontWeight:600,color:modelId===cm.id?Tc.blue:Tc.muted}}>{cm.name}</span>
                </div>
                {modelId===cm.id&&<div style={{position:'absolute',top:5,right:5,width:16,height:16,background:Tc.blue,borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:9,color:'#fff',fontWeight:900}}>✓</div>}
                {cm.isGradient&&<div style={{position:'absolute',top:5,left:5,fontSize:9,background:'rgba(0,0,0,0.5)',color:'#fff',padding:'2px 5px',borderRadius:4}}>∿</div>}
              </div>
            ))}
          </div>
        </div>
      </div>

       {/* ── Modèles sauvegardés ── */}
<div style={cardS}>
  <SH bg="#f3e8ff" color="#6d28d9" icon="💾" title={businesscardcreatorText("t009", "My saved templates")}
    extra={`${savedModels.length} modèle(s)`}/>

  <div style={{ padding: 14, display: 'flex', flexDirection: 'column', gap: 14 }}>

    {/* ── Action bar ── */}
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
      <button
        onClick={() => setSaveDialogOpen(v => !v)}
        style={{
          padding: '8px 16px', borderRadius: 8, fontSize: 12, fontWeight: 700,
          cursor: 'pointer', fontFamily: 'inherit',
          border: 'none', background: Tc.green, color: '#fff',
          display: 'flex', alignItems: 'center', gap: 6,
          boxShadow: '0 2px 6px rgba(29,158,117,0.3)',
          transition: 'all .15s',
        }}
        onMouseOver={e => e.currentTarget.style.opacity = '0.88'}
        onMouseOut={e  => e.currentTarget.style.opacity = '1'}
      >{__elakayText("t101", "💾 Sauvegarder le design actuel")}</button>

      {savedModels.length > 0 && (
        <>
          <button
            onClick={exportModelsAsJson}
            style={{
              padding: '7px 14px', borderRadius: 8, fontSize: 11,
              cursor: 'pointer', fontFamily: 'inherit',
              border: `0.5px solid ${Tc.borderMid}`,
              background: Tc.light, color: Tc.muted,
            }}
            title={businesscardcreatorText("t010", "Download all templates as JSON")}
          >{businesscardcreatorText("t011", "Export")}</button>

          <label style={{
            padding: '7px 14px', borderRadius: 8, fontSize: 11,
            cursor: 'pointer', fontFamily: 'inherit',
            border: `0.5px solid ${Tc.borderMid}`,
            background: Tc.light, color: Tc.muted,
            display: 'inline-flex', alignItems: 'center', gap: 4,
          }}>{__elakayText("t102", "📥 Importer")}<input type="file" accept=".json" style={{ display: 'none' }}
              onChange={e => importModelsFromJson(e.target.files[0])}/>
          </label>
        </>
      )}
    </div>

    {/* ── Save dialog (inline) ── */}
    {saveDialogOpen && (
      <div style={{
        background: Tc.greenBg,
        border: `1px solid ${Tc.green}`,
        borderRadius: 10,
        padding: 12,
        display: 'flex', flexDirection: 'column', gap: 10,
      }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: Tc.green }}>{__elakayText("t103", "💾 Nommer ce modèle")}</div>
        <input
          type="text"
          value={modelNameInput}
          onChange={e => setModelNameInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && saveCurrentModel()}
          placeholder={elakayAutoText("h_887f4f21d17fee", "Modèle {value0}", { value0: savedModels.length + 1 })}
          autoFocus
          style={{
            ...inputS, height: 36,
            border: `1px solid ${Tc.green}`,
          }}
        />
        <div style={{ display: 'flex', gap: 6 }}>
          <button
            onClick={() => saveCurrentModel()}
            style={{
              flex: 1, padding: '8px', borderRadius: 7, fontSize: 12, fontWeight: 700,
              cursor: 'pointer', fontFamily: 'inherit',
              border: 'none', background: Tc.green, color: '#fff',
            }}
          >{businesscardcreatorText("t012", "Confirm")}</button>
          <button
            onClick={() => { setSaveDialogOpen(false); setModelNameInput(''); }}
            style={{
              flex: 1, padding: '8px', borderRadius: 7, fontSize: 12,
              cursor: 'pointer', fontFamily: 'inherit',
              border: `0.5px solid ${Tc.borderMid}`, background: Tc.white, color: Tc.muted,
            }}
          >{businesscardcreatorText("t013", "Cancel")}</button>
        </div>
        <div style={{ fontSize: 10, color: Tc.muted, lineHeight: 1.4 }}>{__elakayText("t104", "ℹ️ Les informations personnelles (nom, email, téléphone, adresse) ne sont")}<strong>{__elakayText("t211", "pas")}</strong>{__elakayText("t105", "sauvegardées. Seul le design (couleurs, modèle, layout, QR, image de fond, etc.) est conservé.")}</div>
      </div>
    )}

    {/* ── Saved models grid ── */}
    {savedModels.length === 0 ? (
      <div style={{
        padding: 24, textAlign: 'center',
        background: Tc.light, borderRadius: 10,
        color: Tc.muted, fontSize: 12,
      }}>{__elakayText("t106", "Aucun modèle sauvegardé.")}<br/>
        <span style={{ fontSize: 11 }}>{__elakayText("t107", "Personnalisez votre carte puis cliquez sur \"💾 Sauvegarder\" pour la réutiliser plus tard.")}</span>
      </div>
    ) : (
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
        gap: 10,
      }}>
        {savedModels.map(saved => {
          const isSelected = selectedSavedId === saved.id;
          const baseModel = CARD_MODELS.find(c => c.id === saved.modelId) || CARD_MODELS[0];

          return (
            <div key={saved.id} style={{
              borderRadius: 10, overflow: 'hidden',
              border: isSelected ? `2.5px solid ${Tc.blue}` : `1px solid ${Tc.border}`,
              boxShadow: isSelected
                ? `0 0 0 3px ${Tc.blueBg}, 0 4px 12px rgba(0,0,0,0.1)`
                : '0 1px 4px rgba(0,0,0,0.06)',
              transition: 'all .15s',
              background: Tc.white,
              position: 'relative',
            }}>
              {/* Mini preview */}
              <div
                onClick={() => loadSavedModel(saved)}
                style={{
                  cursor: 'pointer',
                  background: '#e0e0e0',
                  padding: 6,
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                }}>
                <CardFace
                  model={saved.modelId}
                  info={{ firstName:'Prénom', lastName:'Nom', title: saved.info?.title || 'Titre', email:'', phone:'', website:'', address:'', role: saved.info?.role || '' }}
                  qrCanvas={null}
                  scale={150 / 540}
                  ov={saved.ov || {}}
                  logoStyle={saved.logoStyle || {}}
                  blocks={saved.blocks || DEFAULT_BLOCKS}
                  bgGrad={saved.bgGradId === 'custom'
                    ? { stops: saved.bgCustom?.threeStop ? [saved.bgCustom.c1, saved.bgCustom.c2, saved.bgCustom.c3] : [saved.bgCustom?.c1, saved.bgCustom?.c2], dir: saved.bgCustom?.dir }
                    : (BG_GRADIENTS.find(g => g.id === saved.bgGradId)?.stops ? { stops: BG_GRADIENTS.find(g => g.id === saved.bgGradId).stops, dir: BG_GRADIENTS.find(g => g.id === saved.bgGradId).dir } : null)}
                  bgImage={saved.bgImage}
                  bgImageOpacity={saved.bgImageOpacity ?? 100}
                  bgModelOpacity={saved.bgModelOpacity ?? 100}
                  bgImageFit={saved.bgImageFit || 'cover'}
                  bgImageBlur={saved.bgImageBlur ?? 0}
                />
                {/* Badges */}
                {saved.bgImage && (
                  <div style={{
                    position: 'absolute', top: 8, left: 8,
                    fontSize: 9, padding: '2px 6px', borderRadius: 8,
                    background: 'rgba(0,0,0,0.7)', color: '#fff',
                  }}>{businesscardcreatorText("t015", "Image")}</div>
                )}
                {isSelected && (
                  <div style={{
                    position: 'absolute', top: 8, right: 8,
                    width: 22, height: 22, borderRadius: '50%',
                    background: Tc.blue, color: '#fff',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 12, fontWeight: 900,
                    boxShadow: '0 2px 6px rgba(0,112,204,0.5)',
                  }}>✓</div>
                )}
              </div>

              {/* Info bar */}
              <div style={{ padding: '8px 10px' }}>
                <div style={{
                  fontSize: 12, fontWeight: 700, color: Tc.text,
                  whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                  marginBottom: 2,
                }}>{saved.name}</div>
                <div style={{ fontSize: 9, color: Tc.muted, display: 'flex', justifyContent: 'space-between' }}>
                  <span>{baseModel.name}</span>
                  <span>{new Date(saved.createdAt).toLocaleDateString()}</span>
                </div>

                {/* Actions */}
                <div style={{ display: 'flex', gap: 4, marginTop: 8 }}>
                  <button
                    onClick={() => loadSavedModel(saved)}
                    style={{
                      flex: 1, padding: '5px', borderRadius: 5, fontSize: 10,
                      cursor: 'pointer', fontFamily: 'inherit',
                      border: 'none', background: Tc.blue, color: '#fff', fontWeight: 600,
                    }}
                    title={businesscardcreatorText("t016", "Apply this template")}
                  >{businesscardcreatorText("t017", "Load")}</button>

                  <button
                    onClick={() => {
                      const newName = prompt(__elakayText("t212", "Nouveau nom :"), saved.name);
                      if (newName?.trim()) renameSavedModel(saved.id, newName.trim());
                    }}
                    style={{
                      padding: '5px 8px', borderRadius: 5, fontSize: 11,
                      cursor: 'pointer', fontFamily: 'inherit',
                      border: `0.5px solid ${Tc.borderMid}`,
                      background: Tc.light, color: Tc.muted,
                    }}
                    title={__elakayText("t213", "Renommer")}
                  >✎</button>

                  <button
                    onClick={() => duplicateSavedModel(saved)}
                    style={{
                      padding: '5px 8px', borderRadius: 5, fontSize: 11,
                      cursor: 'pointer', fontFamily: 'inherit',
                      border: `0.5px solid ${Tc.borderMid}`,
                      background: Tc.light, color: Tc.muted,
                    }}
                    title={__elakayText("t214", "Dupliquer")}
                  >⎘</button>

                  <button
                    onClick={() => deleteSavedModel(saved.id)}
                    style={{
                      padding: '5px 8px', borderRadius: 5, fontSize: 11,
                      cursor: 'pointer', fontFamily: 'inherit',
                      border: `0.5px solid #dc354533`,
                      background: 'transparent', color: '#dc3545',
                    }}
                    title={businesscardcreatorText("t020", "Delete")}
                  >🗑</button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    )}

    {/* Hint */}
    {savedModels.length > 0 && (
      <div style={{
        background: Tc.blueBg,
        border: `0.5px solid ${Tc.blue}30`,
        borderRadius: 8,
        padding: '8px 12px',
        fontSize: 11,
        color: Tc.blue,
        lineHeight: 1.5,
      }}>
        💡 <strong>{businesscardcreatorText("t021", "Astuce :")}</strong>{__elakayText("t108", "Cliquez sur l'aperçu ou sur \"▶ Charger\" pour appliquer un modèle sauvegardé. Vos informations personnelles (nom, email, etc.) ne seront pas modifiées.")}</div>
    )}
  </div>
</div>
      {/* Bouton flottant pour ré-attacher l'aperçu */}
{isPreviewFloating && (
  <button
    onClick={() => setIsPreviewFloating(false)}
    title={__elakayText("t109", "Réintégrer l'aperçu")}
    style={{
      position: "fixed",
      bottom: 20, right: 20,
      width: 52, height: 52,
      borderRadius: "50%",
      border: "none",
      background: `linear-gradient(135deg, ${Tc.blue} 0%, #0099ff 100%)`,
      color: "#fff",
      fontSize: 22,
      cursor: "pointer",
      boxShadow: "0 8px 24px rgba(0,112,204,0.4)",
      zIndex: 10000,
      display: "flex", alignItems: "center", justifyContent: "center",
      transition: "transform .2s, box-shadow .2s",
    }}
    onMouseOver={e => { e.currentTarget.style.transform = "scale(1.08)"; }}
    onMouseOut={e  => { e.currentTarget.style.transform = "scale(1)"; }}
  >
    👁
  </button>
)}

      {/* ── Preview ── */}
    {/* ── Preview ── */}
<FloatingPanel
  title={businesscardcreatorText("t022", "Live preview - 85mm x 55mm")}
  isFloating={isPreviewFloating}
  onToggleFloat={() => setIsPreviewFloating(v => !v)}
  defaultPos={{ x: window.innerWidth - 620, y: 80 }}
  defaultSize={{ w: 600, h: 420 }}
  margins={{ top: 12, bottom: 12, left: 12, right: 12 }}
>
  <div style={cardS}>
    {/* Header avec bouton détacher */}
    <div style={{ position: "relative" }}>
      <SH bg="#e1f5ee" color="#085041" icon="👁" title={businesscardcreatorText("t023", "Live preview")} extra="85mm × 55mm" />
      {!isPreviewFloating && (
        <button
          onClick={() => setIsPreviewFloating(true)}
          title={__elakayText("t110", "Détacher l'aperçu (toujours visible pendant le scroll)")}
          style={{
            position: "absolute", top: 8, right: 10,
            padding: "4px 12px", borderRadius: 7, fontSize: 11,
            border: `0.5px solid ${Tc.borderMid}`,
            background: Tc.white, color: Tc.muted,
            cursor: "pointer", fontFamily: "inherit",
            display: "flex", alignItems: "center", gap: 5,
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            transition: "all .15s",
          }}
          onMouseOver={e => { e.currentTarget.style.background = Tc.blueBg; e.currentTarget.style.color = Tc.blue; e.currentTarget.style.borderColor = Tc.blue; }}
          onMouseOut={e  => { e.currentTarget.style.background = Tc.white;  e.currentTarget.style.color = Tc.muted; e.currentTarget.style.borderColor = Tc.borderMid; }}
        >{__elakayText("t111", "⇱ Détacher")}</button>
      )}
    </div>

    {/* Card preview itself */}
    <div style={{
      padding: 20,
      background: '#e0e0e0',
      display: 'flex',
      justifyContent: 'center',
      overflow: 'auto',
      maxHeight: isPreviewFloating ? 'calc(100% - 50px)' : 'none',
    }}>
  <CardFace
  model={modelId}
  info={info}
  qrCanvas={qrCanvas}
  scale={1}
  ov={ov}
  logoStyle={logoStyle}
  blocks={blocks}
  editing={editMode}
  bgGrad={activeBgGrad}
  selectedBlock={selectedBlock}
  onSelectBlock={setSelectedBlock}
  onDragBlock={updateBlock}
  /* ✨ NEW props */
  bgImage={bgImage}
  bgImageOpacity={bgImageOpacity}
  bgModelOpacity={bgModelOpacity}
  bgImageFit={bgImageFit}
  bgImageBlur={bgImageBlur}
/>
    </div>
  </div>
</FloatingPanel>

{/* ── Image de fond personnalisée ── */}
<div style={cardS}>
  <SH bg="#fff3e0" color="#c45000" icon="🖼" title={businesscardcreatorText("t024", "Custom background image")}
    extra={bgImage ? "✓ Image active" : "Aucune image"}/>
  <div style={{padding:14,display:'flex',flexDirection:'column',gap:14}}>

    {/* Upload zone */}
    <div style={{display:'flex',gap:14,flexWrap:'wrap',alignItems:'flex-start'}}>
      <input ref={bgImageUpRef} type="file" accept="image/*" style={{display:'none'}}
        onChange={async e => {
          const f = e.target.files[0];
          if (!f) return;
          const reader = new FileReader();
          reader.onload = ev => setBgImage(ev.target.result);
          reader.readAsDataURL(f);
        }}/>
      <div onClick={() => bgImageUpRef.current.click()}
        onDrop={e => {
          e.preventDefault();
          const f = e.dataTransfer.files[0];
          if (!f?.type.startsWith('image/')) return;
          const reader = new FileReader();
          reader.onload = ev => setBgImage(ev.target.result);
          reader.readAsDataURL(f);
        }}
        onDragOver={e => e.preventDefault()}
        style={{
          width:120, height:80, borderRadius:10, cursor:'pointer',
          border: bgImage ? `2px solid ${Tc.blue}` : `2px dashed ${Tc.borderMid}`,
          background: bgImage ? `url(${bgImage}) center/cover` : Tc.light,
          display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center',
          position:'relative', overflow:'hidden',
        }}>
        {!bgImage && <>
          <span style={{fontSize:28, color:Tc.muted}}>🖼</span>
          <span style={{fontSize:10, color:Tc.muted, textAlign:'center', padding:'0 6px'}}>{__elakayText("t112", "Cliquer ou glisser une image")}</span>
        </>}
        {bgImage && <div style={{
          position:'absolute', bottom:0, left:0, right:0,
          background:'rgba(0,0,0,0.6)', color:'#fff',
          padding:'3px 6px', fontSize:10, textAlign:'center',
        }}>{businesscardcreatorText("t025", "Changer")}</div>}
      </div>

      {bgImage && (
        <div style={{flex:1, minWidth:200, display:'flex', flexDirection:'column', gap:10}}>
          {/* Mode d'ajustement */}
          <div>
            <label style={{fontSize:10,color:Tc.muted,display:'block',marginBottom:6}}>{__elakayText("t113", "Ajustement de l'image")}</label>
            <div style={{display:'flex', gap:5}}>
              {[
                {id:'cover',   l:'Remplir',  d:'Couvre toute la carte'},
                {id:'contain', l:'Adapter',  d:'Image entière visible'},
                {id:'stretch', l:'Étirer',   d:'Étire sur toute la carte'},
              ].map(o => (
                <button key={o.id} onClick={() => setBgImageFit(o.id)}
                  title={o.d}
                  style={{
                    flex:1, padding:'5px 4px', borderRadius:7, fontSize:11,
                    cursor:'pointer', fontFamily:'inherit',
                    border:`0.5px solid ${bgImageFit === o.id ? Tc.blue : Tc.border}`,
                    background: bgImageFit === o.id ? Tc.blueBg : Tc.light,
                    color: bgImageFit === o.id ? Tc.blue : Tc.muted,
                  }}>{o.l}</button>
              ))}
            </div>
          </div>

          <button onClick={() => setBgImage(null)}
            style={{
              padding:'5px 12px', borderRadius:7, fontSize:11, cursor:'pointer',
              fontFamily:'inherit', border:`0.5px solid #dc3545`,
              background:'transparent', color:'#dc3545',
              alignSelf:'flex-start',
            }}>{__elakayText("t114", "🗑 Retirer l'image")}</button>
        </div>
      )}
    </div>

    {/* Sliders d'opacité — toujours visibles */}
    <div style={{borderTop:`0.5px solid ${Tc.border}`, paddingTop:14, display:'flex', flexDirection:'column', gap:12}}>
      {bgImage && (
        <>
          <SliderRow
            label={__elakayText("t115", "🖼 Opacité de l'image de fond")}
            min={0} max={100} value={bgImageOpacity}
            onChange={setBgImageOpacity} unit="%"/>
          <SliderRow
            label={__elakayText("t116", "✨ Flou de l'image (blur)")}
            min={0} max={20} value={bgImageBlur}
            onChange={setBgImageBlur} unit="px"/>
        </>
      )}
      <SliderRow
        label={businesscardcreatorText("t026", "Template opacity (gradient/color)")}
        min={0} max={100} value={bgModelOpacity}
        onChange={setBgModelOpacity} unit="%"/>
    </div>

    {/* Hint */}
    <div style={{
      background:Tc.blueBg, border:`0.5px solid ${Tc.blue}30`, borderRadius:8,
      padding:'8px 12px', fontSize:11, color:Tc.blue, lineHeight:1.5,
    }}>
      <strong>{businesscardcreatorText("t027", "Tip:")}</strong>{__elakayText("t117", "Réduisez l'opacité du modèle (")}{bgModelOpacity}{__elakayText("t118", "%) pour laisser apparaître votre image en dessous.")}{bgImage && bgModelOpacity === 100 && (
        <div style={{marginTop:4, color:Tc.warn || '#c45000'}}>{__elakayText("t119", "⚠ Le modèle est à 100% — votre image n'est pas visible. Baissez ce slider !")}</div>
      )}
    </div>

    {/* Quick presets */}
    <div style={{display:'flex', gap:6, flexWrap:'wrap'}}>
      <span style={{fontSize:10, color:Tc.muted, alignSelf:'center', marginRight:4}}>{__elakayText("t120", "Mélanges rapides :")}</span>
      {[
        {l:'Image seule',   img:100, mod:0,   blur:0},
        {l:'Image dominante',img:100, mod:30,  blur:0},
        {l:'Équilibré',     img:80,  mod:60,  blur:0},
        {l:'Modèle dominant',img:50, mod:90,  blur:2},
        {l:'Image floue',   img:100, mod:50,  blur:6},
      ].map(p => (
        <button key={p.l}
          disabled={!bgImage}
          onClick={() => {
            setBgImageOpacity(p.img);
            setBgModelOpacity(p.mod);
            setBgImageBlur(p.blur);
          }}
          style={{
            padding:'4px 10px', borderRadius:20, fontSize:10, cursor: bgImage ? 'pointer' : 'not-allowed',
            fontFamily:'inherit', border:`0.5px solid ${Tc.borderMid}`,
            background:Tc.light, color: bgImage ? Tc.muted : '#bbb',
            opacity: bgImage ? 1 : 0.5,
          }}>{p.l}</button>
      ))}
    </div>
  </div>
</div>

  {/* ── Info form ── */}
<div style={cardS}>
  <SH bg="#fff3e0" color="#c45000" icon="✏️" title={businesscardcreatorText("t028", "Your information")}
    extra={addresses.length > 0 ? `${addresses.length} adresse(s) enregistrée(s)` : null}/>

  <div style={{ padding: 14, display: 'flex', flexDirection: 'column', gap: 14 }}>

    {/* ✨ NEW : Sélecteur d'adresses enregistrées */}
    {addresses.length > 0 && (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <label style={{ fontSize: 11, fontWeight: 600, color: Tc.text }}>{__elakayText("t121", "📍 Remplir depuis une adresse enregistrée")}</label>
          {selectedAddressId && (
            <button onClick={clearForm}
              style={{
                padding: '3px 10px', borderRadius: 6, fontSize: 10,
                cursor: 'pointer', fontFamily: 'inherit',
                border: `0.5px solid ${Tc.borderMid}`,
                background: Tc.light, color: Tc.muted,
              }}
            >{businesscardcreatorText("t029", "Clear the form")}</button>
          )}
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
          gap: 8,
        }}>
          {addresses.map(addr => {
            const isSelected = selectedAddressId === addr._id;
            return (
              <button
                key={addr._id}
                onClick={() => fillFromAddress(addr)}
                style={{
                  textAlign: 'left',
                  padding: '10px 12px',
                  borderRadius: 10,
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                  background: isSelected ? Tc.blueBg : Tc.white,
                  border: isSelected ? `2px solid ${Tc.blue}` : `1px solid ${Tc.border}`,
                  boxShadow: isSelected
                    ? `0 0 0 3px ${Tc.blue}22, 0 2px 6px rgba(0,0,0,0.08)`
                    : '0 1px 3px rgba(0,0,0,0.04)',
                  transition: 'all .15s',
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 4,
                }}
                onMouseOver={e => {
                  if (!isSelected) {
                    e.currentTarget.style.borderColor = Tc.blue;
                    e.currentTarget.style.background = Tc.blueBg + '55';
                  }
                }}
                onMouseOut={e => {
                  if (!isSelected) {
                    e.currentTarget.style.borderColor = Tc.border;
                    e.currentTarget.style.background = Tc.white;
                  }
                }}
              >
                {/* Header — nom + badges */}
                <div style={{
                  display: 'flex', alignItems: 'center', gap: 6,
                  fontSize: 13, fontWeight: 700, color: Tc.text,
                }}>
                  <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {addr.firstName} {addr.lastName}
                  </span>
                  {addr.addressDefault && (
                    <span style={{
                      fontSize: 8, padding: '2px 6px', borderRadius: 10,
                      background: Tc.green, color: '#fff', fontWeight: 700,
                      letterSpacing: 0.3, whiteSpace: 'nowrap',
                    }}>{businesscardcreatorText("t030", "Default")}</span>
                  )}
                  {addr.BillAddress && (
                    <span style={{
                      fontSize: 8, padding: '2px 6px', borderRadius: 10,
                      background: '#c45000', color: '#fff', fontWeight: 700,
                      letterSpacing: 0.3, whiteSpace: 'nowrap',
                    }}>{businesscardcreatorText("t031", "FACT.")}</span>
                  )}
                </div>

                {/* Boutique */}
                {addr.shopName && (
                  <div style={{
                    fontSize: 10, color: Tc.blue, fontWeight: 600,
                    textTransform: 'uppercase', letterSpacing: 0.5,
                  }}>
                    🏪 {addr.shopName}
                  </div>
                )}

                {/* Adresse */}
                <div style={{ fontSize: 11, color: Tc.muted, lineHeight: 1.4 }}>
                  {addr.Address1}
                  {addr.Address2 && <>, {addr.Address2}</>}
                  <br />
                  {addr.city}, {addr.State} {addr.postalCode}
                  <br />
                  <span style={{ textTransform: 'uppercase', fontSize: 10 }}>{addr.country}</span>
                </div>

                {/* Téléphone */}
                {addr.tel && (
                  <div style={{ fontSize: 10, color: Tc.muted, marginTop: 2 }}>
                    📞 {addr.tel}
                  </div>
                )}

                {/* Check icon if selected */}
                {isSelected && (
                  <div style={{
                    position: 'absolute', top: 8, right: 8,
                    width: 20, height: 20, borderRadius: '50%',
                    background: Tc.blue, color: '#fff',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 11, fontWeight: 900,
                    boxShadow: '0 2px 6px rgba(0,112,204,0.4)',
                  }}>✓</div>
                )}
              </button>
            );
          })}
        </div>

        {/* Hint */}
        <div style={{
          fontSize: 10, color: Tc.muted, fontStyle: 'italic',
          padding: '4px 0',
        }}>{__elakayText("t122", "💡 Cliquez sur une adresse pour pré-remplir le nom, téléphone et adresse. Les autres champs (titre, email, rôle) restent modifiables manuellement.")}</div>
      </div>
    )}

    {/* Séparateur visuel */}
    {addresses.length > 0 && (
      <div style={{
        borderTop: `1px dashed ${Tc.border}`,
        margin: '4px 0',
      }}/>
    )}

    {/* ─── Champs du formulaire (existant) ─── */}
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
      {[
        {k:'firstName',lbl:'Prénom',ph:'Jean',full:false},
        {k:'lastName', lbl:'Nom',ph:'Dupont',full:false},
        {k:'title',    lbl:'Titre',ph:'Directeur Commercial',full:true},
        {k:'role',     lbl:'Badge / Rôle',ph:'Royalty Member',full:true},
        {k:'email',    lbl:'Email',ph:'jean@elakay.com',full:false},
        {k:'phone',    lbl:'Téléphone',ph:'+1 555 000 0000',full:false},
        {k:'website',  lbl:'Site web',ph:'www.elakay.com',full:false},
        {k:'address',  lbl:'Adresse',ph:'New York, NY',full:false},
      ].map(({k,lbl,ph,full}) => (
        <div key={k} style={{
          gridColumn: full ? '1/-1' : undefined,
          display: 'flex', flexDirection: 'column', gap: 4,
        }}>
          <label style={{ fontSize: 10, color: Tc.muted, display: 'flex', alignItems: 'center', gap: 4 }}>
            {lbl}
            {/* ✨ Badge "auto-rempli" sur les champs venant de l'adresse sélectionnée */}
            {selectedAddressId && ['firstName','lastName','phone','address','website'].includes(k) && info[k] && (
              <span style={{
                fontSize: 8, padding: '1px 5px', borderRadius: 8,
                background: Tc.greenBg, color: Tc.green, fontWeight: 700,
                letterSpacing: 0.3,
              }}>{businesscardcreatorText("t032", "AUTO")}</span>
            )}
          </label>
          <input
            type="text"
            placeholder={ph}
            value={info[k]}
            style={inputS}
            onChange={e => {
              setField(k, e.target.value);
              // Si l'utilisateur modifie un champ auto-rempli, on désélectionne l'adresse
              if (selectedAddressId && ['firstName','lastName','phone','address'].includes(k)) {
                setSelectedAddressId(null);
              }
            }}
            onFocus={e => {
              e.target.style.borderColor = Tc.blue;
              e.target.style.boxShadow = '0 0 0 2px rgba(0,112,204,0.1)';
            }}
            onBlur={e => {
              e.target.style.borderColor = Tc.borderMid;
              e.target.style.boxShadow = 'none';
            }}
          />
        </div>
      ))}
    </div>
  </div>
</div>

      {/* ── Logo Elakay ── */}
      <div style={cardS}>
        <SH bg="#e0f0ff" color="#0070cc" icon="⭐" title={__elakayText("t123", "Logo & Marque Elakay")}/>
        <div style={{padding:14,display:'flex',flexDirection:'column',gap:14}}>
          <div style={{display:'flex',gap:14,flexWrap:'wrap',alignItems:'flex-start'}}>
            <div style={{flexShrink:0,display:'flex',flexDirection:'column',alignItems:'center',gap:6}}>
             <div style={{
  width: 80, height: 80,
  border: `0.5px solid ${Tc.border}`,
  /* ✨ Damier pour montrer la transparence */
  background: logoStyle.transparentBg
    ? 'repeating-conic-gradient(#e0e0e0 0% 25%, #f8f8f8 0% 50%) 0 0 / 12px 12px'
    : Tc.light,
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  overflow: 'hidden', borderRadius: 8,
  position: 'relative',
}}>
  {logoStyle.show !== false && (
    <div style={{
      background: logoStyle.transparentBg ? 'transparent' : (logoStyle.customBg || '#ffffff'),
      padding: logoStyle.bgPadding || 0,
      borderRadius: logoStyle.radius,
      boxShadow: !logoStyle.transparentBg && (logoStyle.bgPadding || 0) > 0
        ? `0 1px 3px rgba(0,0,0,0.15)` : 'none',
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <img
        src={ELAKAY_LOGO}
        alt={businesscardcreatorText("t034", "logo")}
        style={{
          width: logoStyle.size * 2,
          height: logoStyle.size * 2,
          objectFit: 'contain',
          borderRadius: logoStyle.radius,
          display: 'block',
        }}
      />
    </div>
  )}
</div>
              <span style={{fontSize:9,color:Tc.muted}}>{businesscardcreatorText("t035", "Preview")}</span>
            </div>
            <div style={{flex:1,minWidth:200,display:'flex',flexDirection:'column',gap:10}}>
              <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
                <TB label={logoStyle.show!==false?elakayAutoText("h_89565341642e2a", "✓ Logo visible"):elakayAutoText("h_fd68e5924a07a2", "Logo caché")} active={logoStyle.show!==false} onClick={()=>setLS('show',!(logoStyle.show!==false))}/>
                <TB label={logoStyle.showText!==false?elakayAutoText("h_75016c0d516c9f", "✓ Texte ELAKAY"):elakayAutoText("h_f7c5abda62f645", "Texte caché")} active={logoStyle.showText!==false} onClick={()=>setLS('showText',!(logoStyle.showText!==false))}/>
              </div>
              {/* {logoStyle.show!==false&&<><SliderRow label="Logo size" min={12} max={52} value={logoStyle.size} onChange={v=>setLS('size',v)} unit="px"/><SliderRow label="Rounded" min={0} max={50} value={logoStyle.radius} onChange={v=>setLS('radius',v)} unit="px"/></>} */}

              {logoStyle.show !== false && (
  <>
    <SliderRow label={businesscardcreatorText("t096", "Logo size")} min={12} max={52} value={logoStyle.size} onChange={v=>setLS('size',v)} unit="px"/>
    <SliderRow label={businesscardcreatorText("t039", "Rounded")} min={0} max={50} value={logoStyle.radius} onChange={v=>setLS('radius',v)} unit="px"/>

    {/* ✨ NEW : Contrôle du fond du logo */}
    <div style={{
      borderTop: `0.5px solid ${Tc.border}`,
      paddingTop: 10,
      display: 'flex', flexDirection: 'column', gap: 8,
    }}>
      <label style={{ fontSize: 10, color: Tc.muted, fontWeight: 600 }}>{__elakayText("t124", "Fond du logo")}</label>

      {/* Toggle transparent / opaque */}
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        <TB
          label={logoStyle.transparentBg ? elakayAutoText("h_d66cd25238e701", "✓ Sans fond (transparent)") : elakayAutoText("h_90203f2c09f00f", "Sans fond")}
          active={logoStyle.transparentBg}
          onClick={() => setLS('transparentBg', true)}
        />
        <TB
          label={!logoStyle.transparentBg ? elakayAutoText("h_4c9eca74529ec4", "✓ Avec fond") : elakayAutoText("h_9ddee1d645efe5", "Avec fond")}
          active={!logoStyle.transparentBg}
          onClick={() => setLS('transparentBg', false)}
        />
      </div>

      {/* Si fond actif → couleur + padding */}
      {!logoStyle.transparentBg && (
        <div style={{
          display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end',
          background: Tc.light, padding: 10, borderRadius: 8,
        }}>
          <CR
            label={businesscardcreatorText("t040", "Background color")}
            value={logoStyle.customBg || '#ffffff'}
            onChange={v => setLS('customBg', v)}
            presets={['#ffffff','#000000','#f5f5f5','#fef9e7','#e8f3ff','#ffe8e8','#e8ffe8','#fff5e8']}
          />
          <div style={{ flex: 1, minWidth: 130 }}>
            <SliderRow
              label={__elakayText("t125", "Padding (espace autour)")}
              min={0} max={20} value={logoStyle.bgPadding || 0}
              onChange={v => setLS('bgPadding', v)}
              unit="px"
            />
          </div>
        </div>
      )}

      {/* Hint */}
      <div style={{
        fontSize: 10, color: Tc.muted, lineHeight: 1.4,
        padding: '4px 0',
      }}>
        💡 {logoStyle.transparentBg
          ? elakayAutoText("h_0164b3ec02030c", "Le logo apparaît directement sur la carte sans cadre.")
          : elakayAutoText("h_d78c7826397a20", "Un fond coloré encadre le logo (idéal sur arrière-plans foncés ou photo).")}
      </div>
    </div>
  </>
)}

              {logoStyle.showText!==false&&<>
                <div style={{display:'flex',gap:10,flexWrap:'wrap',alignItems:'flex-end'}}>
                  <div style={{flex:1,minWidth:120,display:'flex',flexDirection:'column',gap:4}}>
                    <label style={{fontSize:10,color:Tc.muted}}>{businesscardcreatorText("t042", "Brand text")}</label>
                    <input type="text" value={logoStyle.brandText||'ELAKAY'} maxLength={20} onChange={e=>setLS('brandText',e.target.value)} style={{...inputS,height:30,fontSize:11}}/>
                  </div>
                  <SliderRow label={businesscardcreatorText("t043", "Text size")} min={7} max={18} value={logoStyle.textSize} onChange={v=>setLS('textSize',v)} unit="px"/>
                </div>
                <div style={{display:'flex',gap:8,flexWrap:'wrap',alignItems:'flex-end'}}>
                  <div style={{display:'flex',gap:5}}><TB label="G" active={logoStyle.textBold} onClick={()=>setLS('textBold',!logoStyle.textBold)}/><TB label="I" active={logoStyle.textItalic} onClick={()=>setLS('textItalic',!logoStyle.textItalic)}/></div>
                  <CR label={businesscardcreatorText("t044", "Text color")} value={logoStyle.textColor||base.accent} onChange={v=>setLS('textColor',v)} presets={COLOR_PRESETS}/>
                </div>
              </>}
            </div>
          </div>
        </div>
      </div>

      {/* ── Gradient du fond de la carte ── */}
      <div style={cardS}>
        <SH bg="#fff3e0" color="#c45000" icon="🎨" title={businesscardcreatorText("t045", "Card background gradient (10 presets + custom)")}/>
        <div style={{padding:14,display:'flex',flexDirection:'column',gap:14}}>

          {/* Preset grid */}
          <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:6}}>
            {BG_GRADIENTS.map(g=>{
              const active = bgGradId===g.id;
              // compute preview gradient
              const stops = g.stops || (active&&bgGradId==='custom'
                ? (bgCustom.threeStop?[bgCustom.c1,bgCustom.c2,bgCustom.c3]:[bgCustom.c1,bgCustom.c2])
                : base.grad);
              const previewBg = stops.length===3
                ? `linear-gradient(135deg,${stops[0]},${stops[1]},${stops[2]})`
                : `linear-gradient(135deg,${stops[0]},${stops[1]})`;
              return (
                <button key={g.id} onClick={()=>setBgGradId(g.id)}
                  style={{ borderRadius:10, cursor:'pointer', overflow:'hidden', padding:0,
                    border: active ? `2.5px solid ${Tc.blue}` : `1.5px solid ${Tc.border}`,
                    boxShadow: active ? `0 0 0 3px ${Tc.blueBg}` : 'none',
                    transition:'all .15s', position:'relative',
                    display:'flex', flexDirection:'column' }}>
                  {/* Color swatch */}
                  <div style={{ height:44, background: g.id==='custom'
                    ? `linear-gradient(135deg,${bgCustom.c1},${bgCustom.c2},${bgCustom.c3})`
                    : previewBg }} />
                  <div style={{ padding:'4px 6px', background: active?Tc.blueBg:Tc.light,
                    fontSize:9, fontWeight:600, color: active?Tc.blue:Tc.muted, textAlign:'center',
                    fontFamily:'inherit', lineHeight:1.3 }}>
                    {g.name}
                  </div>
                  {active && <div style={{ position:'absolute', top:4, right:4, width:14, height:14,
                    background:Tc.blue, borderRadius:'50%', display:'flex', alignItems:'center',
                    justifyContent:'center', fontSize:8, color:'#fff', fontWeight:900 }}>✓</div>}
                </button>
              );
            })}
          </div>

          {/* Direction selector (for non-model presets) */}
          {bgGradId !== 'model' && (
            <div>
              <label style={{fontSize:10,color:Tc.muted,display:'block',marginBottom:6}}>{businesscardcreatorText("t046", "Gradient direction")}</label>
              <div style={{display:'flex',gap:5,flexWrap:'wrap'}}>
                {[{d:'135deg',l:'↘ Diagonal'},{d:'90deg',l:'→ Horizontal'},{d:'180deg',l:'↓ Vertical'},{d:'45deg',l:'↗ Inverse'},{d:'160deg',l:'↙ Oblique'}].map(o=>{
                  const cur = bgGradId==='custom' ? bgCustom.dir : BG_GRADIENTS.find(g=>g.id===bgGradId)?.dir||'135deg';
                  const isA = bgGradId==='custom' ? bgCustom.dir===o.d : BG_GRADIENTS.find(g=>g.id===bgGradId)?.dir===o.d;
                  return (
                    <button key={o.d} onClick={()=>{ if(bgGradId==='custom') setBgC('dir',o.d); }}
                      disabled={bgGradId!=='custom'}
                      style={{ padding:'4px 10px', borderRadius:7, fontSize:10, cursor:bgGradId==='custom'?'pointer':'default',
                        fontFamily:'inherit', border:`0.5px solid ${isA?Tc.blue:Tc.border}`,
                        background:isA?Tc.blueBg:Tc.light, color:isA?Tc.blue:Tc.muted, opacity:bgGradId!=='custom'?0.5:1 }}>
                      {o.l}</button>
                  );
                })}
              </div>
            </div>
          )}

          {/* Custom gradient editor */}
          {bgGradId === 'custom' && (
            <div style={{background:Tc.light,borderRadius:10,padding:12,display:'flex',flexDirection:'column',gap:12}}>
              <div style={{fontSize:11,fontWeight:600,color:Tc.text}}>{businesscardcreatorText("t047", "Custom colors")}</div>

              {/* 2 or 3 stops toggle */}
              <div style={{display:'flex',gap:8,alignItems:'center'}}>
                <TB label={bgCustom.threeStop ? elakayAutoText("h_65e3128cc342a2", "3 couleurs") : elakayAutoText("h_5ab3e3e090bc19", "2 couleurs")} active={bgCustom.threeStop}
                  onClick={()=>setBgC('threeStop',!bgCustom.threeStop)}/>
                <span style={{fontSize:10,color:Tc.muted}}>{businesscardcreatorText("t048", "Number of color points")}</span>
              </div>

              {/* Color stops */}
              <div style={{display:'flex',gap:12,flexWrap:'wrap'}}>
                {(['c1','c2',...(bgCustom.threeStop?['c3']:[])]).map((ck,i)=>(
                  <div key={ck} style={{display:'flex',flexDirection:'column',gap:4}}>
                    <label style={{fontSize:10,color:Tc.muted}}>{__elakayText("t215", "Couleur")}{i+1}</label>
                    <div style={{display:'flex',alignItems:'center',gap:6}}>
                      <input type="color" value={bgCustom[ck]}
                        onChange={e=>setBgC(ck,e.target.value)}
                        style={{width:36,height:30,border:`0.5px solid ${Tc.border}`,borderRadius:6,cursor:'pointer',padding:2}}/>
                      <input type="text" value={bgCustom[ck]} maxLength={7}
                        onChange={e=>{if(/^#[0-9a-fA-F]{0,6}$/.test(e.target.value))setBgC(ck,e.target.value);}}
                        style={{width:72,height:30,padding:'0 7px',borderRadius:6,border:`0.5px solid ${Tc.borderMid}`,fontSize:11,fontFamily:'monospace',outline:'none'}}/>
                    </div>
                    {/* Quick presets for this stop */}
                    <div style={{display:'flex',gap:3,flexWrap:'wrap'}}>
                      {['#000000','#0a0a1a','#1a1200','#001830','#0d0221','#ffffff','#f8f9fa','#1a1a2e','#071a0d','#0d0000'].map(c=>(
                        <div key={c} onClick={()=>setBgC(ck,c)} style={{width:16,height:16,borderRadius:3,cursor:'pointer',background:c,
                          border:bgCustom[ck]===c?`2px solid ${Tc.blue}`:`1px solid ${Tc.border}`}}/>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              {/* Live preview bar */}
              <div style={{height:28,borderRadius:8,border:`0.5px solid ${Tc.border}`,
                background:bgCustom.threeStop
                  ?`linear-gradient(${bgCustom.dir},${bgCustom.c1},${bgCustom.c2},${bgCustom.c3})`
                  :`linear-gradient(${bgCustom.dir},${bgCustom.c1},${bgCustom.c2})`}}/>
            </div>
          )}
        </div>
      </div>

      {/* ── 20 Presets de mise en page ── */}
      <div style={cardS}>
        <SH bg="#e0f0ff" color="#0070cc" icon="⊞" title={businesscardcreatorText("t049", "20 professional layout presets")}/>
        <div style={{padding:14,display:'flex',flexDirection:'column',gap:10}}>
          <p style={{margin:0,fontSize:11,color:Tc.muted}}>{businesscardcreatorText("t050", "Click a preset to instantly apply the block layout.")}</p>
          <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:6}}>
            {LAYOUT_PRESETS.map(p=>{
              // Check if current blocks match this preset (approx)
              const isActive = JSON.stringify(blocks?.logo)===JSON.stringify(p.blocks.logo)
                && JSON.stringify(blocks?.info)===JSON.stringify(p.blocks.info)
                && JSON.stringify(blocks?.qr)===JSON.stringify(p.blocks.qr);
              return (
                <button key={p.id} onClick={()=>setBlocks(p.blocks)}
                  style={{ padding:'8px 4px', borderRadius:9, cursor:'pointer', fontFamily:'inherit',
                    border:`1.5px solid ${isActive?Tc.blue:Tc.border}`,
                    background:isActive?Tc.blueBg:Tc.light,
                    color:isActive?Tc.blue:Tc.muted, transition:'all .13s',
                    display:'flex', flexDirection:'column', alignItems:'center', gap:3 }}>
                  <span style={{fontSize:18}}>{p.icon}</span>
                  <span style={{fontSize:9,fontWeight:600,lineHeight:1.3,textAlign:'center'}}>{p.name}</span>
                </button>
              );
            })}
          </div>
          <div style={{display:'flex',justifyContent:'flex-end',marginTop:4}}>
            <button onClick={resetBlocks}
              style={{padding:'5px 14px',borderRadius:7,fontSize:11,cursor:'pointer',fontFamily:'inherit',
                border:`0.5px solid ${Tc.borderMid}`,background:Tc.light,color:Tc.muted}}>{__elakayText("t126", "↺ Positions par défaut")}</button>
          </div>
        </div>
      </div>

      {/* ── Éditeur de position libre ── */}
      <div style={cardS}>
        <SH bg="#e1f5ee" color="#085041" icon="⊞" title={businesscardcreatorText("t051", "Free block positioning")}/>
        <div style={{padding:14,display:'flex',flexDirection:'column',gap:14}}>

          {/* Mode toggle */}
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:8}}>
            <div style={{display:'flex',flexDirection:'column',gap:3}}>
              <span style={{fontSize:12,fontWeight:600,color:Tc.text}}>{businesscardcreatorText("t052", "Edit mode")}</span>
              <span style={{fontSize:10,color:Tc.muted}}>{businesscardcreatorText("t053", "Enable, then drag each block directly on the preview")}</span>
            </div>
            <button onClick={()=>{setEditMode(v=>!v);setSelectedBlock(null);}}
              style={{padding:'8px 18px',borderRadius:20,fontSize:12,fontWeight:700,cursor:'pointer',fontFamily:'inherit',transition:'all .2s',
                border:`1.5px solid ${editMode?Tc.green:Tc.borderMid}`,
                background:editMode?Tc.greenBg:Tc.light,
                color:editMode?Tc.green:Tc.muted,
                boxShadow:editMode?`0 0 0 3px ${Tc.green}22`:undefined}}>
              {editMode ? elakayAutoText("h_c4303976342c7a", "✏️ Mode édition actif") : elakayAutoText("h_65f1c095ec52bb", "▷ Activer l'édition")}
            </button>
          </div>

          {editMode && (
            <>
              {/* Instruction */}
              <div style={{background:Tc.blueBg,border:`0.5px solid ${Tc.blue}30`,borderRadius:8,padding:'8px 12px',fontSize:11,color:Tc.blue,lineHeight:1.5}}>
                <strong>{businesscardcreatorText("t054", "How to use:")}</strong>{__elakayText("t127", "Cliquez sur un bloc dans l'aperçu pour le sélectionner (contour pointillé), puis glissez-le n'importe où sur la carte.")}</div>

              {/* Block selector */}
              <div>
                <label style={{fontSize:10,color:Tc.muted,display:'block',marginBottom:8}}>{businesscardcreatorText("t055", "Select a block to move")}</label>
                <div style={{display:'flex',gap:8}}>
                  {[
                    {id:'logo', icon:'⭐', label:__elakayText("t128", "Logo Elakay")},
                    {id:'info', icon:'📋', label:__elakayText("t216", "Informations")},
                    {id:'qr',   icon:'▪',  label:__elakayText("t129", "QR Code")},
                  ].map(b=>(
                    <button key={b.id} onClick={()=>setSelectedBlock(prev=>prev===b.id?null:b.id)}
                      style={{flex:1,padding:'10px 6px',borderRadius:10,cursor:'pointer',fontFamily:'inherit',transition:'all .15s',
                        border:`1.5px solid ${selectedBlock===b.id?Tc.blue:Tc.border}`,
                        background:selectedBlock===b.id?Tc.blueBg:Tc.white,
                        color:selectedBlock===b.id?Tc.blue:Tc.muted,
                        boxShadow:selectedBlock===b.id?`0 0 0 3px ${Tc.blueBg}`:undefined,
                        display:'flex',flexDirection:'column',alignItems:'center',gap:4}}>
                      <span style={{fontSize:22}}>{b.icon}</span>
                      <span style={{fontSize:10,fontWeight:600}}>{b.label}</span>
                      {selectedBlock===b.id && <span style={{fontSize:9,color:Tc.blue}}>{businesscardcreatorText("t056", "Drag on the card")}</span>}
                    </button>
                  ))}
                </div>
              </div>

              {/* Position fine XY for selected block */}
              {selectedBlock && (
                <div style={{background:Tc.light,borderRadius:10,padding:12,display:'flex',flexDirection:'column',gap:10}}>
                  <div style={{fontSize:11,fontWeight:600,color:Tc.text}}>{__elakayText("t130", "Position fine —")}{selectedBlock==='logo'?elakayAutoText("h_62d9e4f0c6301c", "Logo Elakay"):selectedBlock==='info'?elakayAutoText("h_54937b3a4f8cfa", "Informations"):elakayAutoText("h_44742187d5d4b1", "QR Code")}
                  </div>
                  <div style={{display:'flex',gap:16,flexWrap:'wrap'}}>
                    <div style={{flex:1,minWidth:160}}>
                      <div style={{display:'flex',justifyContent:'space-between',marginBottom:4}}>
                        <label style={{fontSize:10,color:Tc.muted}}>{businesscardcreatorText("t057", "Left / Right Position")}</label>
                        <span style={{fontSize:11,color:Tc.blue,fontWeight:700}}>{Math.round(blocks[selectedBlock]?.x||0)}%</span>
                      </div>
                      <input type="range" min={0} max={90} step={0.5}
                        value={blocks[selectedBlock]?.x||0}
                        onChange={e=>updateBlock(selectedBlock,{...blocks[selectedBlock],x:+e.target.value})}
                        style={{width:'100%',accentColor:Tc.blue}}/>
                    </div>
                    <div style={{flex:1,minWidth:160}}>
                      <div style={{display:'flex',justifyContent:'space-between',marginBottom:4}}>
                        <label style={{fontSize:10,color:Tc.muted}}>{businesscardcreatorText("t058", "Top / Bottom Position")}</label>
                        <span style={{fontSize:11,color:Tc.blue,fontWeight:700}}>{Math.round(blocks[selectedBlock]?.y||0)}%</span>
                      </div>
                      <input type="range" min={0} max={85} step={0.5}
                        value={blocks[selectedBlock]?.y||0}
                        onChange={e=>updateBlock(selectedBlock,{...blocks[selectedBlock],y:+e.target.value})}
                        style={{width:'100%',accentColor:Tc.blue}}/>
                    </div>
                  </div>
                  {/* Quick snap buttons */}
                  <div>
                    <label style={{fontSize:10,color:Tc.muted,display:'block',marginBottom:6}}>{__elakayText("t131", "Positions rapides")}</label>
                    <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:5,maxWidth:280}}>
                      {[
                        {l:'↖',x:3,y:5},{l:'↑',x:38,y:5},{l:'↗',x:73,y:5},
                        {l:'←',x:3,y:40},{l:'·',x:38,y:40},{l:'→',x:73,y:40},
                        {l:'↙',x:3,y:75},{l:'↓',x:38,y:75},{l:'↘',x:73,y:75},
                      ].map(p=>(
                        <button key={p.l} onClick={()=>updateBlock(selectedBlock,{x:p.x,y:p.y})}
                          style={{height:32,borderRadius:7,fontSize:14,cursor:'pointer',fontFamily:'inherit',
                            border:`0.5px solid ${Tc.border}`,background:Tc.white,color:Tc.muted,transition:'all .1s'}}
                          onMouseOver={e=>{e.currentTarget.style.borderColor=Tc.blue;e.currentTarget.style.color=Tc.blue;}}
                          onMouseOut={e=>{e.currentTarget.style.borderColor=Tc.border;e.currentTarget.style.color=Tc.muted;}}
                        >{p.l}</button>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* Text align for info block */}
              <div>
                <label style={{fontSize:10,color:Tc.muted,display:'block',marginBottom:6}}>{businesscardcreatorText("t060", "Text alignment (information block)")}</label>
                <div style={{display:'flex',gap:5}}>
                  {[{id:'left',l:'≡ Gauche'},{id:'center',l:'≡ Centre'},{id:'right',l:'≡ Droite'}].map(o=>(
                    <button key={o.id} onClick={()=>setBlocks(p=>({...p,info:{...p.info,textAlign:o.id}}))}
                      style={{flex:1,padding:'6px 4px',borderRadius:7,fontSize:11,cursor:'pointer',fontFamily:'inherit',
                        border:`0.5px solid ${(blocks.info?.textAlign||'left')===o.id?Tc.blue:Tc.border}`,
                        background:(blocks.info?.textAlign||'left')===o.id?Tc.blueBg:Tc.light,
                        color:(blocks.info?.textAlign||'left')===o.id?Tc.blue:Tc.muted,transition:'all .12s'}}>{o.l}</button>
                  ))}
                </div>
              </div>
            </>
          )}

          {/* Reset & presets */}
          <div style={{display:'flex',gap:8,flexWrap:'wrap',borderTop:`0.5px solid ${Tc.border}`,paddingTop:12}}>
            <button onClick={resetBlocks}
              style={{padding:'6px 14px',borderRadius:7,fontSize:11,cursor:'pointer',fontFamily:'inherit',border:`0.5px solid ${Tc.borderMid}`,background:Tc.light,color:Tc.muted}}>{__elakayText("t126", "↺ Positions par défaut")}</button>
            {/* Preset layouts */}
            {[
              {l:'← Info | QR →', b:{logo:{x:3,y:5},info:{x:3,y:26},qr:{x:65,y:8}}},
              {l:'QR → | Info →', b:{logo:{x:3,y:5},info:{x:40,y:26},qr:{x:3,y:8}}},
              {l:'Tout centré',    b:{logo:{x:38,y:5},info:{x:25,y:28},qr:{x:72,y:22}}},
              {l:'Logo haut-centré',b:{logo:{x:43,y:4},info:{x:5,y:28},qr:{x:68,y:8}}},
            ].map(p=>(
              <button key={p.l} onClick={()=>setBlocks(p.b)}
                style={{padding:'6px 12px',borderRadius:7,fontSize:10,cursor:'pointer',fontFamily:'inherit',border:`0.5px solid ${Tc.borderMid}`,background:Tc.light,color:Tc.muted,transition:'all .12s'}}
                onMouseOver={e=>{e.currentTarget.style.background=Tc.blueBg;e.currentTarget.style.color=Tc.blue;}}
                onMouseOut={e=>{e.currentTarget.style.background=Tc.light;e.currentTarget.style.color=Tc.muted;}}
              >{p.l}</button>
            ))}
          </div>
        </div>
      </div>

      {/* ── Texte & couleurs ── */}
      <div style={cardS}>
        <SH bg="#f3e8ff" color="#6d28d9" icon="🖌" title={businesscardcreatorText("t061", "Text style & card colors")}/>
        <div style={{padding:14,display:'flex',flexDirection:'column',gap:18}}>
          <div><label style={{fontSize:10,color:Tc.muted,display:'block',marginBottom:6}}>{businesscardcreatorText("t062", "Font")}</label>
            <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
              {FONTS.map(f=>{const short=f.split(',')[0].trim();const active=(ov.font||base.font)===f;return(
                <button key={f} onClick={()=>setO('font',f)} style={{padding:'5px 10px',borderRadius:7,fontSize:11,cursor:'pointer',fontFamily:f,border:`0.5px solid ${active?Tc.blue:Tc.borderMid}`,background:active?Tc.blueBg:Tc.light,color:active?Tc.blue:Tc.muted,transition:'all .12s'}}>{short}</button>
              );})}
            </div>
          </div>
          <div style={{display:'flex',flexDirection:'column',gap:10,borderTop:`0.5px solid ${Tc.border}`,paddingTop:14}}>
            <div style={{fontSize:11,fontWeight:600,color:Tc.text}}>{__elakayText("t063", "Full name")}</div>
            <div style={{display:'flex',gap:10,flexWrap:'wrap',alignItems:'flex-end'}}>
              <SliderRow label={businesscardcreatorText("t067", "Size")} min={12} max={28} step={0.5} value={ov.nameSz||18} onChange={v=>setO('nameSz',v)} unit="px"/>
              <div style={{display:'flex',gap:5}}><TB label="G" active={!!ov.nameBold} onClick={()=>setO('nameBold',!ov.nameBold)}/><TB label="I" active={!!ov.nameItalic} onClick={()=>setO('nameItalic',!ov.nameItalic)}/><TB label="S" active={!!ov.nameUnder} onClick={()=>setO('nameUnder',!ov.nameUnder)}/></div>
              <CR label={businesscardcreatorText("t065", "Name color")} value={ov.nameColor||base.text} onChange={v=>setO('nameColor',v)} presets={COLOR_PRESETS}/>
            </div>
          </div>
          <div style={{display:'flex',flexDirection:'column',gap:10,borderTop:`0.5px solid ${Tc.border}`,paddingTop:14}}>
            <div style={{fontSize:11,fontWeight:600,color:Tc.text}}>{businesscardcreatorText("t066", "Title / Position")}</div>
            <div style={{display:'flex',gap:10,flexWrap:'wrap',alignItems:'flex-end'}}>
              <SliderRow label={businesscardcreatorText("t067", "Size")} min={6} max={14} step={0.5} value={ov.titleSz||8.5} onChange={v=>setO('titleSz',v)} unit="px"/>
              <div style={{display:'flex',gap:5}}><TB label="G" active={!!ov.titleBold} onClick={()=>setO('titleBold',!ov.titleBold)}/><TB label="I" active={!!ov.titleItalic} onClick={()=>setO('titleItalic',!ov.titleItalic)}/></div>
              <CR label={businesscardcreatorText("t068", "Title color")} value={ov.titleColor||base.accent} onChange={v=>setO('titleColor',v)} presets={COLOR_PRESETS}/>
            </div>
          </div>
          {/* Badge / Role -- independent size/style/color (was hardcoded to
              the card's accent color and a fixed 6.5px/bold before). */}
          <div style={{display:'flex',flexDirection:'column',gap:10,borderTop:`0.5px solid ${Tc.border}`,paddingTop:14}}>
            <div style={{fontSize:11,fontWeight:600,color:Tc.text}}>{businesscardcreatorText("t218", "Badge / Role")}</div>
            <div style={{display:'flex',gap:10,flexWrap:'wrap',alignItems:'flex-end'}}>
              <SliderRow label={businesscardcreatorText("t067", "Size")} min={5} max={12} step={0.5} value={ov.roleSz||6.5} onChange={v=>setO('roleSz',v)} unit="px"/>
              <div style={{display:'flex',gap:5}}><TB label="G" active={ov.roleBold!==false} onClick={()=>setO('roleBold',ov.roleBold===false?true:false)}/><TB label="I" active={!!ov.roleItalic} onClick={()=>setO('roleItalic',!ov.roleItalic)}/></div>
              <CR label={businesscardcreatorText("t219", "Badge color")} value={ov.roleColor||base.accent} onChange={v=>setO('roleColor',v)} presets={COLOR_PRESETS}/>
            </div>
          </div>
          {/* Email */}
          <div style={{display:'flex',flexDirection:'column',gap:10,borderTop:`0.5px solid ${Tc.border}`,paddingTop:14}}>
            <div style={{fontSize:11,fontWeight:600,color:Tc.text}}>{businesscardcreatorText("t220", "Email")}</div>
            <div style={{display:'flex',gap:10,flexWrap:'wrap',alignItems:'flex-end'}}>
              <SliderRow label={businesscardcreatorText("t067", "Size")} min={5} max={12} step={0.5} value={ov.emailSz||ov.contactSz||7.5} onChange={v=>setO('emailSz',v)} unit="px"/>
              <div style={{display:'flex',gap:5}}><TB label="G" active={!!ov.emailBold} onClick={()=>setO('emailBold',!ov.emailBold)}/><TB label="I" active={!!ov.emailItalic} onClick={()=>setO('emailItalic',!ov.emailItalic)}/></div>
              <CR label={businesscardcreatorText("t221", "Email color")} value={ov.emailColor||ov.subColor||base.sub} onChange={v=>setO('emailColor',v)} presets={COLOR_PRESETS}/>
            </div>
          </div>
          {/* Phone */}
          <div style={{display:'flex',flexDirection:'column',gap:10,borderTop:`0.5px solid ${Tc.border}`,paddingTop:14}}>
            <div style={{fontSize:11,fontWeight:600,color:Tc.text}}>{businesscardcreatorText("t222", "Phone")}</div>
            <div style={{display:'flex',gap:10,flexWrap:'wrap',alignItems:'flex-end'}}>
              <SliderRow label={businesscardcreatorText("t067", "Size")} min={5} max={12} step={0.5} value={ov.phoneSz||ov.contactSz||7.5} onChange={v=>setO('phoneSz',v)} unit="px"/>
              <div style={{display:'flex',gap:5}}><TB label="G" active={!!ov.phoneBold} onClick={()=>setO('phoneBold',!ov.phoneBold)}/><TB label="I" active={!!ov.phoneItalic} onClick={()=>setO('phoneItalic',!ov.phoneItalic)}/></div>
              <CR label={businesscardcreatorText("t223", "Phone color")} value={ov.phoneColor||ov.subColor||base.sub} onChange={v=>setO('phoneColor',v)} presets={COLOR_PRESETS}/>
            </div>
          </div>
          {/* Website */}
          <div style={{display:'flex',flexDirection:'column',gap:10,borderTop:`0.5px solid ${Tc.border}`,paddingTop:14}}>
            <div style={{fontSize:11,fontWeight:600,color:Tc.text}}>{businesscardcreatorText("t224", "Website")}</div>
            <div style={{display:'flex',gap:10,flexWrap:'wrap',alignItems:'flex-end'}}>
              <SliderRow label={businesscardcreatorText("t067", "Size")} min={5} max={12} step={0.5} value={ov.websiteSz||ov.contactSz||7.5} onChange={v=>setO('websiteSz',v)} unit="px"/>
              <div style={{display:'flex',gap:5}}><TB label="G" active={!!ov.websiteBold} onClick={()=>setO('websiteBold',!ov.websiteBold)}/><TB label="I" active={!!ov.websiteItalic} onClick={()=>setO('websiteItalic',!ov.websiteItalic)}/></div>
              <CR label={businesscardcreatorText("t225", "Website color")} value={ov.websiteColor||ov.accentColor||base.accent2} onChange={v=>setO('websiteColor',v)} presets={COLOR_PRESETS}/>
            </div>
          </div>
          {/* Address */}
          <div style={{display:'flex',flexDirection:'column',gap:10,borderTop:`0.5px solid ${Tc.border}`,paddingTop:14}}>
            <div style={{fontSize:11,fontWeight:600,color:Tc.text}}>{businesscardcreatorText("t226", "Address")}</div>
            <div style={{display:'flex',gap:10,flexWrap:'wrap',alignItems:'flex-end'}}>
              <SliderRow label={businesscardcreatorText("t067", "Size")} min={5} max={12} step={0.5} value={ov.addressSz||ov.contactSz||7} onChange={v=>setO('addressSz',v)} unit="px"/>
              <div style={{display:'flex',gap:5}}><TB label="G" active={!!ov.addressBold} onClick={()=>setO('addressBold',!ov.addressBold)}/><TB label="I" active={!!ov.addressItalic} onClick={()=>setO('addressItalic',!ov.addressItalic)}/></div>
              <CR label={businesscardcreatorText("t227", "Address color")} value={ov.addressColor||ov.subColor||base.sub} onChange={v=>setO('addressColor',v)} presets={COLOR_PRESETS}/>
            </div>
          </div>
          {/* Card accent -- drives the divider, QR frame, badge glow and
              selection outline; kept separate from the 7 field colors
              above (each field now has its own dedicated color). */}
          <div style={{display:'flex',flexDirection:'column',gap:10,borderTop:`0.5px solid ${Tc.border}`,paddingTop:14}}>
            <div style={{fontSize:11,fontWeight:600,color:Tc.text}}>{businesscardcreatorText("t228", "Card accent")}</div>
            <div style={{display:'flex',gap:10,flexWrap:'wrap',alignItems:'flex-end'}}>
              <CR label={businesscardcreatorText("t072", "Accent color")} value={ov.accentColor||base.accent} onChange={v=>setO('accentColor',v)} presets={COLOR_PRESETS}/>
            </div>
          </div>
          <div style={{display:'flex',justifyContent:'flex-end'}}><button onClick={()=>setOv({})} style={{padding:'5px 14px',borderRadius:7,fontSize:11,cursor:'pointer',fontFamily:'inherit',border:`0.5px solid ${Tc.borderMid}`,background:Tc.light,color:Tc.muted}}>{businesscardcreatorText("t073", "Reset")}</button></div>
        </div>
      </div>

      {/* ── QR Data ── */}
      {/* <div style={cardS}>
        <SH bg="#f3e8ff" color="#6d28d9" icon="▪" title="QR code data"/>
        <div style={{padding:14,display:'flex',flexDirection:'column',gap:10}}>
          <input type="text" value={qrData} style={inputS} placeholder="https://elakay.com" onChange={e=>setQrData(e.target.value)}
            onFocus={e=>{e.target.style.borderColor=Tc.blue;e.target.style.boxShadow='0 0 0 2px rgba(0,112,204,0.1)';}}
            onBlur={e=>{e.target.style.borderColor=Tc.borderMid;e.target.style.boxShadow='none';}}/>
          <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
            {[{l:'Site web',v:'https://elakay.com'},{l:'Email',v:`mailto:${info.email||'vous@elakay.com'}`},{l:'Tél.',v:`tel:${info.phone||'+15550000000'}`},{l:'LinkedIn',v:'https://linkedin.com/in/'}].map(p=>(
              <button key={p.l} onClick={()=>setQrData(p.v)} style={{padding:'4px 12px',borderRadius:20,fontSize:10,cursor:'pointer',fontFamily:'inherit',border:`0.5px solid ${Tc.borderMid}`,background:Tc.light,color:Tc.muted}}
                onMouseOver={e=>{e.currentTarget.style.background=Tc.blueBg;e.currentTarget.style.color=Tc.blue;}}
                onMouseOut={e=>{e.currentTarget.style.background=Tc.light;e.currentTarget.style.color=Tc.muted;}}>{p.l}</button>
            ))}
          </div>
        </div>
      </div> */}


      {/* ── Sélection / Création du QR code ── */}
<div style={cardS}>
  <SH bg="#f3e8ff" color="#6d28d9" icon="▪" title={businesscardcreatorText("t075", "Choose the QR code")}
    extra={`${allQrs.length} disponibles`}/>

  <div style={{ padding: 14, display: 'flex', flexDirection: 'column', gap: 14 }}>

    {/* ── Mode toggle ── */}
    <div style={{ display: 'flex', gap: 4, background: Tc.light, padding: 3, borderRadius: 22, alignSelf: 'flex-start' }}>
      {[
        { id: 'gallery', l: '🖼 Galerie' },
        { id: 'url',     l: '🔗 URL' },
        { id: 'upload',  l: '📤 Importer' },
      ].map(m => (
        <button key={m.id} onClick={() => setQrMode(m.id)}
          style={{
            padding: '5px 14px', borderRadius: 18, fontSize: 11, fontWeight: 600,
            cursor: 'pointer', fontFamily: 'inherit', border: 'none',
            background: qrMode === m.id ? Tc.white : 'transparent',
            color: qrMode === m.id ? Tc.blue : Tc.muted,
            boxShadow: qrMode === m.id ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
            transition: 'all .15s',
          }}>{m.l}</button>
      ))}
    </div>

    {/* ── Mode: Galerie ── */}
    {qrMode === 'gallery' && (
      <>
        <label style={{ fontSize: 11, color: Tc.muted, fontWeight: 600 }}>{__elakayText("t132", "Sélectionnez un QR code prédéfini ou importé")}</label>

        {/* QR Thumbs */}
        <div style={{
          display: 'flex', gap: 10, overflowX: 'auto',
          paddingBottom: 8, alignItems: 'flex-start',
        }}>
          {DEFAULT_QRS.map(qr => (
            <QrThumb key={qr.id} qr={qr}
              selected={selectedQrId === qr.id}
              onClick={() => selectQr(qr)}/>
          ))}
          {userQrs.length > 0 && (
            <div style={{
              width: 1, alignSelf: 'stretch',
              background: Tc.border, margin: '0 4px',
            }}/>
          )}
          {userQrs.map(qr => (
            <QrThumb key={qr.id} qr={qr}
              isUpload
              selected={selectedQrId === qr.id}
              onClick={() => selectQr(qr)}
              onDelete={() => deleteUserQr(qr.id)}/>
          ))}
          {/* + Upload tile inline */}
          <div style={{
            flexShrink: 0, display: 'flex', flexDirection: 'column',
            alignItems: 'center', gap: 4,
          }}>
            <input ref={qrGalleryUpRef} type="file" accept="image/*" style={{ display: 'none' }}
              onChange={e => { addUserQr(e.target.files[0]); e.target.value = ''; }}/>
            <div onClick={() => qrGalleryUpRef.current.click()}
              onDrop={e => { e.preventDefault(); addUserQr(e.dataTransfer.files[0]); }}
              onDragOver={e => e.preventDefault()}
              style={{
                width: 78, height: 78, cursor: 'pointer',
                borderRadius: 8, border: `1.5px dashed ${Tc.borderMid}`,
                background: Tc.light,
                display: 'flex', flexDirection: 'column',
                alignItems: 'center', justifyContent: 'center', gap: 2,
                transition: 'all .15s',
              }}
              onMouseOver={e => {
                e.currentTarget.style.borderColor = Tc.blue;
                e.currentTarget.style.background = Tc.blueBg;
              }}
              onMouseOut={e => {
                e.currentTarget.style.borderColor = Tc.borderMid;
                e.currentTarget.style.background = Tc.light;
              }}>
              <span style={{ fontSize: 22, color: Tc.muted }}>+</span>
              <span style={{ fontSize: 9, color: Tc.muted, textAlign: 'center', padding: '0 4px' }}>{__elakayText("t217", "Importer")}</span>
            </div>
            <span style={{ fontSize: 9, color: Tc.muted }}>{businesscardcreatorText("t076", "My QR codes")}</span>
          </div>
        </div>

        {/* Selected info */}
        {selectedQrId && (
          <div style={{
            background: Tc.blueBg,
            border: `0.5px solid ${Tc.blue}30`,
            borderRadius: 8,
            padding: '8px 12px',
            fontSize: 11,
            color: Tc.blue,
            display: 'flex', alignItems: 'center', gap: 8,
          }}>
            <span style={{ fontSize: 14 }}>✓</span>
            <span>
              <strong>{allQrs.find(q => q.id === selectedQrId)?.label}</strong>
              {allQrs.find(q => q.id === selectedQrId)?.url && (
                <span style={{ marginLeft: 8, opacity: 0.7, fontFamily: 'monospace', fontSize: 10 }}>
                  → {allQrs.find(q => q.id === selectedQrId).url}
                </span>
              )}
            </span>
          </div>
        )}
      </>
    )}

    {/* ── Mode: URL personnalisée ── */}
    {qrMode === 'url' && (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <label style={{ fontSize: 11, color: Tc.muted, fontWeight: 600 }}>{__elakayText("t133", "Générer un QR code depuis une URL ou texte")}</label>
        <div style={{ display: 'flex', gap: 8 }}>
          <input
            type="text"
            value={qrData}
            placeholder="https://elakay.com/ma-page"
            style={{ ...inputS, flex: 1 }}
            onChange={e => setQrData(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && generateCustomQr(qrData)}
            onFocus={e => { e.target.style.borderColor = Tc.blue; e.target.style.boxShadow = '0 0 0 2px rgba(0,112,204,0.1)'; }}
            onBlur={e  => { e.target.style.borderColor = Tc.borderMid; e.target.style.boxShadow = 'none'; }}/>
          <button
            onClick={() => generateCustomQr(qrData)}
            disabled={!qrData.trim()}
            style={{
              padding: '0 16px', height: 34, borderRadius: 8, fontSize: 12, fontWeight: 600,
              border: 'none', background: qrData.trim() ? Tc.blue : Tc.light,
              color: qrData.trim() ? '#fff' : Tc.muted,
              cursor: qrData.trim() ? 'pointer' : 'not-allowed',
              fontFamily: 'inherit',
            }}
          >{businesscardcreatorText("t077", "Generate")}</button>
        </div>

        {/* Quick URLs */}
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 10, color: Tc.muted, alignSelf: 'center' }}>{__elakayText("t134", "Raccourcis :")}</span>
          {[
            { l: '🌐 Site',     v: 'https://elakay.com' },
            { l: '📧 Email',    v: `mailto:${info.email || 'vous@elakay.com'}` },
            { l: '📞 Tél.',     v: `tel:${info.phone || '+15550000000'}` },
            { l: '💼 LinkedIn', v: 'https://linkedin.com/in/' },
            { l: '💬 WhatsApp', v: `https://wa.me/${(info.phone || '').replace(/\D/g, '')}` },
          ].map(p => (
            <button key={p.l} onClick={() => { setQrData(p.v); generateCustomQr(p.v); }}
              style={{
                padding: '4px 10px', borderRadius: 16, fontSize: 10,
                cursor: 'pointer', fontFamily: 'inherit',
                border: `0.5px solid ${Tc.borderMid}`,
                background: Tc.light, color: Tc.muted,
                transition: 'all .12s',
              }}
              onMouseOver={e => { e.currentTarget.style.background = Tc.blueBg; e.currentTarget.style.color = Tc.blue; }}
              onMouseOut={e  => { e.currentTarget.style.background = Tc.light;  e.currentTarget.style.color = Tc.muted; }}
            >{p.l}</button>
          ))}
        </div>
      </div>
    )}

    {/* ── Mode: Upload direct (image QR existante) ── */}
    {qrMode === 'upload' && (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <label style={{ fontSize: 11, color: Tc.muted, fontWeight: 600 }}>{__elakayText("t135", "Importer une image QR depuis votre appareil")}</label>

        <input ref={qrGalleryUpRef} type="file" accept="image/*" style={{ display: 'none' }}
          onChange={e => { addUserQr(e.target.files[0]); e.target.value = ''; }}/>

        <div onClick={() => qrGalleryUpRef.current.click()}
          onDrop={e => { e.preventDefault(); addUserQr(e.dataTransfer.files[0]); }}
          onDragOver={e => e.preventDefault()}
          style={{
            border: `2px dashed ${Tc.borderMid}`,
            borderRadius: 12, padding: 24,
            background: Tc.light,
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center', gap: 8,
            cursor: 'pointer', transition: 'all .15s',
          }}
          onMouseOver={e => {
            e.currentTarget.style.borderColor = Tc.blue;
            e.currentTarget.style.background = Tc.blueBg;
          }}
          onMouseOut={e => {
            e.currentTarget.style.borderColor = Tc.borderMid;
            e.currentTarget.style.background = Tc.light;
          }}>
          <span style={{ fontSize: 36, color: Tc.muted }}>📤</span>
          <span style={{ fontSize: 13, fontWeight: 600, color: Tc.text }}>{__elakayText("t136", "Cliquer ou glisser une image QR")}</span>
          <span style={{ fontSize: 11, color: Tc.muted }}>{__elakayText("t137", "PNG, JPG, SVG accepté · max 2 MB")}</span>
        </div>

        {/* Loaded user QRs */}
        {userQrs.length > 0 && (
          <>
            <label style={{ fontSize: 11, color: Tc.muted, fontWeight: 600, marginTop: 6 }}>{__elakayText("t138", "Mes QR codes importés (")}{userQrs.length})
            </label>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
              {userQrs.map(qr => (
                <QrThumb key={qr.id} qr={qr}
                  isUpload
                  selected={selectedQrId === qr.id}
                  onClick={() => selectQr(qr)}
                  onDelete={() => deleteUserQr(qr.id)}/>
              ))}
            </div>
          </>
        )}
      </div>
    )}

    {/* Status / errors */}
    {qrUrlError && (
      <div style={{
        fontSize: 11, padding: '6px 12px', borderRadius: 7,
        background: qrUrlError.startsWith('✓') ? Tc.greenBg : '#fff0f1',
        color:      qrUrlError.startsWith('✓') ? Tc.green : '#dc3545',
        border: `0.5px solid ${qrUrlError.startsWith('✓') ? Tc.green : '#dc3545'}33`,
      }}>{qrUrlError}</div>
    )}
  </div>
</div>

      {/* ── QR Style ── */}
      <div style={cardS}>
        <SH bg="#e1f5ee" color="#085041" icon="▣" title={businesscardcreatorText("t079", "QR code style")}/>
        <div style={{padding:14,display:'flex',flexDirection:'column',gap:16}}>

          {/* Reset QR to model defaults */}
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
            <span style={{fontSize:11,color:Tc.muted}}>{businesscardcreatorText("t080", "Default template style")}<strong style={{color:Tc.text}}>{base.name}</strong></span>
            <button onClick={()=>{const qd=base.qr;setQrFgColor(qd.fgColor);setQrBgColor(qd.bgColor);setQrBgTransp(qd.bgTransp);setQrCornerRadius(qd.cornerRadius);setQrDotStyle(qd.dotStyle);setGradEnabled(qd.gradEnabled);setGradType(qd.gradType);setGradColor1(qd.gradColor1);setGradColor2(qd.gradColor2);setGradInvert(qd.gradInvert);}}
              style={{padding:'4px 12px',borderRadius:7,fontSize:11,cursor:'pointer',fontFamily:'inherit',border:`0.5px solid ${Tc.borderMid}`,background:Tc.light,color:Tc.muted}}>{businesscardcreatorText("t081", "Template defaults")}</button>
          </div>

          {/* Colors */}
          <div style={{display:'flex',gap:16,flexWrap:'wrap'}}>
            <CR label={businesscardcreatorText("t082", "Modules (foreground)")} value={qrFgColor} onChange={setQrFgColor} presets={['#000000','#0070cc','#1D9E75','#c9a227','#dc2626','#ffffff','#a855f7','#4ade80']}/>
            <CR label={businesscardcreatorText("t083", "Background")} value={qrBgColor} onChange={setQrBgColor} presets={['#ffffff','#000000','#f8f9fa','#0a0a1a','#e8f3ff','#1a1200','#071a0d','#0d0221']}/>
            <div style={{display:'flex',flexDirection:'column',gap:6}}>
              <label style={{fontSize:10,color:Tc.muted}}>{businesscardcreatorText("t084", "Transparent background")}</label>
              <TB label={qrBgTransp?elakayAutoText("h_8b24cf80ead7f4", "✓ Transparent"):elakayAutoText("h_c637aebe3a2825", "Opaque")} active={qrBgTransp} onClick={()=>setQrBgTransp(v=>!v)}/>
            </div>
            <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:4}}>
              <label style={{fontSize:10,color:Tc.muted}}>{businesscardcreatorText("t085", "QR preview")}</label>
              <div style={{width:72,height:72,borderRadius:8,border:`0.5px solid ${Tc.border}`,overflow:'hidden',background:qrBgTransp?'repeating-conic-gradient(#ccc 0% 25%,#fff 0% 50%) 0 0/10px 10px':qrBgColor,display:'flex',alignItems:'center',justifyContent:'center'}}>
                {qrCanvas&&<img src={qrCanvas.toDataURL()} style={{width:'100%',height:'100%',objectFit:'contain'}}/>}
              </div>
            </div>
          </div>

          {/* Dot style */}
          <div style={{borderTop:`0.5px solid ${Tc.border}`,paddingTop:14}}>
            <label style={{fontSize:10,color:Tc.muted,display:'block',marginBottom:8}}>{businesscardcreatorText("t086", "Module style")}</label>
            <div style={{display:'flex',gap:6}}>
              {[{id:'square',emoji:'⬛',lbl:'Carré'},{id:'rounded',emoji:'▣',lbl:'Arrondi'},{id:'dot',emoji:'●',lbl:'Rond'}].map(s=>(
                <button key={s.id} onClick={()=>setQrDotStyle(s.id)} style={{flex:1,padding:'8px 4px',borderRadius:8,cursor:'pointer',border:`1.5px solid ${qrDotStyle===s.id?Tc.blue:Tc.border}`,background:qrDotStyle===s.id?Tc.blueBg:Tc.light,color:qrDotStyle===s.id?Tc.blue:Tc.muted,fontSize:11,fontFamily:'inherit',display:'flex',flexDirection:'column',alignItems:'center',gap:2}}>
                  <span style={{fontSize:18}}>{s.emoji}</span><span>{s.lbl}</span></button>
              ))}
            </div>
            {qrDotStyle==='rounded'&&<div style={{marginTop:10}}><SliderRow label={businesscardcreatorText("t087", "Module radius")} min={0} max={50} value={qrDotRadius} onChange={setQrDotRadius} unit="%"/></div>}
          </div>

          {/* Corner radius */}
          <div style={{borderTop:`0.5px solid ${Tc.border}`,paddingTop:14}}>
            <SliderRow label={businesscardcreatorText("t088", "Global QR border radius")} min={0} max={50} value={qrCornerRadius} onChange={setQrCornerRadius} unit="%"/>
            <div style={{display:'flex',gap:5,marginTop:8}}>
              {[{l:'□ 0',v:0},{l:'▢ 8',v:8},{l:'◻ 20',v:20},{l:'⬤ 50',v:50}].map(p=>(
                <button key={p.v} onClick={()=>setQrCornerRadius(p.v)} style={{flex:1,padding:'4px 2px',borderRadius:6,fontSize:10,cursor:'pointer',fontFamily:'inherit',border:`0.5px solid ${qrCornerRadius===p.v?Tc.blue:Tc.border}`,background:qrCornerRadius===p.v?Tc.blueBg:Tc.light,color:qrCornerRadius===p.v?Tc.blue:Tc.muted}}>{p.l}</button>
              ))}
            </div>
          </div>

          {/* Gradient */}
          <div style={{borderTop:`0.5px solid ${Tc.border}`,paddingTop:14}}>
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:12}}>
              <label style={{fontSize:10,color:Tc.muted}}>{__elakayText("t139", "Dégradé sur les modules")}{base.isGradient&&<span style={{color:Tc.blue,fontWeight:600}}>{businesscardcreatorText("t089", "(enabled by default on this template)")}</span>}</label>
              <TB label={gradEnabled?elakayAutoText("h_443e75ebdc3c88", "✓ Activé"):elakayAutoText("h_2d32fa951d2dc3", "Désactivé")} active={gradEnabled} onClick={()=>setGradEnabled(v=>!v)}/>
            </div>
            {gradEnabled&&(
              <div style={{display:'flex',flexDirection:'column',gap:12}}>
                {/* Type */}
                <div>
                  <label style={{fontSize:10,color:Tc.muted,display:'block',marginBottom:6}}>{businesscardcreatorText("t090", "Gradient type")}</label>
                  <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                    {[{id:'radial',l:'⊙ Radial'},{id:'linear-h',l:'→ Horizontal'},{id:'linear-v',l:'↓ Vertical'},{id:'linear-d',l:'↗ Diagonal'}].map(o=>(
                      <button key={o.id} onClick={()=>setGradType(o.id)} style={{padding:'5px 12px',borderRadius:8,fontSize:11,cursor:'pointer',fontFamily:'inherit',border:`0.5px solid ${gradType===o.id?Tc.blue:Tc.borderMid}`,background:gradType===o.id?Tc.blueBg:Tc.light,color:gradType===o.id?Tc.blue:Tc.muted}}>{o.l}</button>
                    ))}
                  </div>
                </div>
                {/* Colors */}
                <div style={{display:'flex',gap:14,flexWrap:'wrap'}}>
                  <CR label={gradType==='radial'?elakayAutoText("h_16e5447a804601", "Centre"):elakayAutoText("h_f0955314c5266d", "Début")} value={gradColor1} onChange={setGradColor1} presets={['#000000','#0070cc','#1D9E75','#c9a227','#dc2626','#a855f7','#ffffff','#ff6b6b','#f0ff00','#00ffcc']}/>
                  <CR label={gradType==='radial'?elakayAutoText("h_20baf7434c7846", "Bord"):elakayAutoText("h_4251065f15a436", "Fin")} value={gradColor2} onChange={setGradColor2} presets={['#000000','#0070cc','#1D9E75','#c9a227','#dc2626','#a855f7','#ffffff','#ff6b6b','#818cf8','#e879f9']}/>
                </div>
                {/* Preview */}
                <div style={{height:28,borderRadius:8,border:`0.5px solid ${Tc.border}`,background:gradPreviewStyle(gradType,gradColor1,gradColor2,gradInvert),transition:'background .2s'}}/>
                <div style={{display:'flex',gap:8,alignItems:'center'}}>
                  <TB label={businesscardcreatorText("t091", "Invert colors")} active={gradInvert} onClick={()=>setGradInvert(v=>!v)}/>
                  <span style={{fontSize:10,color:Tc.muted}}>{gradType==='radial'?(gradInvert?elakayAutoText("h_ef75b7b8b8c9bf", "Bord→Centre"):elakayAutoText("h_c480b6c84092a0", "Centre→Bord")):(gradInvert?elakayAutoText("h_1209bd54a88bc7", "Fin→Début"):elakayAutoText("h_9644313a456a96", "Début→Fin"))}</span>
                </div>
              </div>
            )}
          </div>

          {/* Logo centre QR */}
          <div style={{borderTop:`0.5px solid ${Tc.border}`,paddingTop:14}}>
            <label style={{fontSize:10,color:Tc.muted,display:'block',marginBottom:8}}>{businesscardcreatorText("t092", "Logo in the center of the QR code")}</label>
            <div style={{display:'flex',gap:14,flexWrap:'wrap',alignItems:'flex-start'}}>
              <div>
                <input ref={qrLogoUpRef} type="file" accept="image/*" style={{display:'none'}} onChange={async e=>{const f=e.target.files[0];if(!f)return;const img=await loadImg(URL.createObjectURL(f));setQrLogoImg(img);}}/>
                <div onClick={()=>qrLogoUpRef.current.click()} style={{width:72,height:72,borderRadius:10,cursor:'pointer',border:qrLogoImg?`2px solid ${Tc.blue}`:`2px dashed ${Tc.borderMid}`,background:Tc.light,overflow:'hidden',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',position:'relative'}}>
                  {qrLogoImg?<><img src={qrLogoImg.src} style={{width:'100%',height:'100%',objectFit:'contain'}}/><div style={{position:'absolute',bottom:3,right:3,fontSize:9,background:'#000a',color:'#fff',padding:'1px 4px',borderRadius:3}}>{businesscardcreatorText("t025", "Changer")}</div></>:<><span style={{fontSize:22,color:Tc.muted}}>+</span><span style={{fontSize:9,color:Tc.muted,textAlign:'center'}}>{businesscardcreatorText("t094", "Logo QR")}</span></>}
                </div>
                {qrLogoImg&&<button onClick={()=>setQrLogoImg(null)} style={{marginTop:4,width:'100%',padding:'3px 0',borderRadius:6,fontSize:10,border:'0.5px solid #dc3545',color:'#dc3545',background:'transparent',cursor:'pointer',fontFamily:'inherit'}}>{__elakayText("t095", "Remove")}</button>}
              </div>
              {qrLogoImg&&<div style={{flex:1,minWidth:180,display:'flex',flexDirection:'column',gap:10}}>
                <SliderRow label={businesscardcreatorText("t096", "Logo size")} min={10} max={45} value={qrLogoPct} onChange={setQrLogoPct} unit="%"/>
                <SliderRow label={businesscardcreatorText("t097", "Corner radius")} min={0} max={50} value={qrLogoRound} onChange={setQrLogoRound} unit="px"/>
                <TB label={qrLogoBg?elakayAutoText("h_407462b5fd5a62", "✓ Fond blanc"):elakayAutoText("h_90203f2c09f00f", "Sans fond")} active={qrLogoBg} onClick={()=>setQrLogoBg(v=>!v)}/>
              </div>}
            </div>
          </div>
        </div>
      </div>

      {/* ── Download ── */}
      <div style={cardS}>
        <SH bg="#e1f5ee" color="#085041" icon="⬇" title={businesscardcreatorText("t098", "Download")}/>
        <div style={{padding:14,display:'flex',flexDirection:'column',gap:10}}>
          <p style={{margin:0,fontSize:11,color:Tc.muted}}>{businesscardcreatorText("t099", "1080x600 px HD card - all styles applied - ready to print.")}</p>
          <button onClick={downloadPng} disabled={busy} style={{height:42,border:'none',borderRadius:9,fontSize:13,fontWeight:700,cursor:busy?'wait':'pointer',fontFamily:'inherit',background:busy?Tc.light:Tc.green,color:busy?Tc.muted:'#fff',display:'flex',alignItems:'center',justifyContent:'center',gap:8,boxShadow:busy?'none':'0 2px 8px rgba(29,158,117,0.3)',transition:'all .2s'}}
            onMouseOver={e=>{if(!busy)e.currentTarget.style.opacity='0.88';}}
            onMouseOut={e=>e.currentTarget.style.opacity='1'}
          >{busy?elakayAutoText("h_15ae02f81603b6", "⏳ Génération…"):elakayAutoText("h_dd377b84b75080", "⬇ Télécharger PNG Haute Résolution")}</button>
        </div>
      </div>

    </div>
  );
}
